<template>
    <v-container fluid>
        <v-toolbar flat color="white">
            <v-toolbar-title>Заявки</v-toolbar-title>
            <v-divider
                    class="mx-2"
                    inset
                    vertical
            ></v-divider>
            <v-btn v-if="this.role == 'ROLE_CUSTOMER_ADMIN' || this.role == 'ROLE_CUSTOMER_WORKER'" @click="addRequest" color="info" dark class="mb-2">Добавить Заявку</v-btn>
            <v-btn v-if="(this.role == 'ROLE_CUSTOMER_ADMIN' || this.role == 'ROLE_CUSTOMER_WORKER') && notSavedRequests.status" @click="unsavedRequests(unsavedRequestKeys)" color="warning" dark class="mb-2">Несохраненные заявки</v-btn>
            <v-btn v-if="this.role == 'ROLE_ADMIN' || this.role == 'ROLE_EXPERT'" :loading="excelLoading" @click="fnExcelReport" color="info" dark class="mb-2">Выгрузка в Excel</v-btn>
            <v-dialog v-if="this.role == 'ROLE_ADMIN' || this.role == 'ROLE_EXPERT'" v-model="wordDialog" max-width="600px">
                <v-btn slot="activator" color="info" dark class="mb-2">Выгрузка отчета</v-btn>

                <v-card>
                    <v-card-title>
                        <v-spacer></v-spacer>
                        <span class="headline">Отчет по заявкам</span>
                        <v-spacer></v-spacer>
                    </v-card-title>

                    <v-alert
                            :value="wordErrorAlert"
                            color="error"
                            icon="warning"

                    >
                        {{wordErrorText}}
                    </v-alert>

                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>

                                    <v-flex xs6>
                                        <v-datetime-picker
                                                label="Дата начала"
                                                v-model="startDateWord"
                                                datetime = "String"
                                                okText="Сохранить"
                                                clearText="Очистить"
                                                locale="ru"
                                        >
                                        </v-datetime-picker>
                                    </v-flex>
                                    <v-flex xs6>
                                        <v-datetime-picker
                                                label="Дата окончания"
                                                v-model="endDateWord"
                                                okText="Сохранить"
                                                clearText="Очистить"
                                                datetime = "String"
                                                locale="ru"
                                        >
                                        </v-datetime-picker>
                                    </v-flex>

                                </v-layout>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" flat @click="wordClose">Отменить</v-btn>
                            <v-btn color="success" flat @click="export2Docx(startDateWord,endDateWord)">Скачать</v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>

                </v-card>
            </v-dialog>
            <v-dialog v-if="this.role == 'ROLE_CUSTOMER_ADMIN' || this.role == 'ROLE_CUSTOMER_WORKER'" v-model="sendDialog" max-width="500px">
                <v-card>
                    <v-card-title>
                        <v-spacer></v-spacer>
                        <span class="headline">Отправка заявку в УУ</span>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-alert
                            :value="sendSuccessAlert"
                            dismissible
                            type="success"
                    >
                        {{sendSuccessText}}
                    </v-alert>
                    <v-alert
                            :value="sendErrorAlert"
                            color="error"
                            icon="warning"

                    >
                        {{sendErrorText}}
                    </v-alert>

                    <v-card-text>
                        <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <v-textarea
                                                row="3"
                                                v-model="sendBidItems.comment"
                                                label="Kомментарий"
                                                required
                                        ></v-textarea>
                                    </v-flex>
                                    <v-flex xs12>
                                        <file-pond
                                                ref="sendFilespond"
                                                label-idle="Прикрепить файлы..."
                                                allow-multiple="true"
                                                v-bind:files="sendFilesArr"
                                                :accepted-file-types="FileTypes"
                                                labelFileTypeNotAllowed="Файл недопустимого типа"
                                                fileValidateTypeLabelExpectedTypes="Допустимы .odt, .docx, .doc, .docm, .pdf, .xlsx, .xls"                                        />
                                    </v-flex>
                                </v-layout>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="sendClose">Отменить</v-btn>
                        <v-btn color="success" flat @click="sendSave(sendBidItems.comment)">Отправить</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-if="this.role == 'ROLE_ADMIN' || this.role == 'ROLE_EXPERT'" v-model="revisionDialog" max-width="500px">
                <v-card>
                    <v-card-title>
                        <v-spacer></v-spacer>
                        <span class="headline">Отправка на доработку</span>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-alert
                            :value="revisionSuccessAlert"
                            dismissible
                            type="success"
                    >
                        {{revisionSuccessText}}
                    </v-alert>
                    <v-alert
                            :value="revisionErrorAlert"
                            color="error"
                            icon="warning"

                    >
                        {{revisionErrorText}}
                    </v-alert>

                    <v-card-text>
                        <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12>
                                        <v-textarea
                                                row="3"
                                                v-model="revisionBidItems.revisionComment"
                                                label="Kомментарий"
                                        ></v-textarea>
                                    </v-flex>
                                    <v-flex xs12>
                                        <file-pond
                                                ref="revisionFilespond"
                                                label-idle="Прикрепить файлы..."
                                                allow-multiple="true"
                                                :accepted-file-types="FileTypes2"
                                                v-bind:files="revisionFilesArr"
                                                labelFileTypeNotAllowed="Файл недопустимого типа"
                                                fileValidateTypeLabelExpectedTypes="Допустимы .odt, .docx, .doc, .docm, .pdf, .xlsx, .xls, .bmp ,.gif, .jpeg, .jpg, .jpe, .jp2, .png, .raw, .7z, .rar, .zip"
                                        />
                                    </v-flex>
                                </v-layout>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="revisionClose">Отменить</v-btn>
                        <v-btn color="blue darken-1" flat @click="revisionSave(revisionBidItems.revisionComment)">Отправить</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-if="this.role == 'ROLE_CUSTOMER_ADMIN' || this.role == 'ROLE_CUSTOMER_WORKER'" v-model="withdrawDialog" max-width="500px">
                <v-card>
                    <v-card-title>
                        <v-spacer></v-spacer>
                        <span class="headline">Отозвать заявку</span>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-alert
                            :value="withdrawSuccessAlert"
                            dismissible
                            type="success"
                    >
                        {{withdrawSuccessText}}
                    </v-alert>
                    <v-alert
                            :value="withdrawErrorAlert"
                            color="error"
                            icon="warning"

                    >
                        {{withdrawErrorText}}
                    </v-alert>
                        <v-card-text>
                            <v-container grid-list-md>

                                <v-layout wrap>
                                    <v-flex xs12>
                                        <v-textarea
                                                row="3"
                                                v-model="withdrawBidItems.withdrawComment"
                                                label="Kомментарий"
                                        ></v-textarea>
                                    </v-flex>
                                    <v-flex xs12>
                                        <file-pond
                                                ref="withdrawFilespond"
                                                label-idle="Прикрепить файлы..."
                                                allow-multiple="true"
                                                :accepted-file-types="FileTypes"
                                                labelFileTypeNotAllowed="Файл недопустимого типа"
                                                fileValidateTypeLabelExpectedTypes="Допустимы .odt, .docx, .doc, .docm, .pdf, .xlsx, .xls"
                                        />
                                    </v-flex>
                                </v-layout>

                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" flat @click="withdrawClose">Отменить</v-btn>
                            <v-btn color="blue darken-1" flat @click="withdrawSave(withdrawBidItems.withdrawComment)">Отправить</v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-if="this.role == 'ROLE_ADMIN' || this.role == 'ROLE_EXPERT'" v-model="acceptDialog" max-width="500px">
                <v-card>
                    <v-card-title>
                        <v-spacer></v-spacer>
                        <span class="headline" style="text-align: center">Принять заявку</span>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-alert
                            :value="acceptSuccessAlert"
                            dismissible
                            type="success"
                    >
                        {{acceptSuccessText}}
                    </v-alert>
                    <v-alert
                            :value="acceptErrorAlert"
                            color="error"
                            icon="warning"

                    >
                        {{acceptErrorText}}
                    </v-alert>

                    <v-card-text>
                        <v-container grid-list-md>

                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-textarea
                                            row="3"
                                            v-model="acceptBidItems.acceptComment"
                                            label="Kомментарий"
                                    ></v-textarea>
                                </v-flex>
                                <v-flex xs12>
                                    <file-pond
                                            ref="acceptFilespond"
                                            label-idle="Прикрепить файлы..."
                                            allow-multiple="true"
                                            :accepted-file-types="FileTypes"
                                            labelFileTypeNotAllowed="Файл недопустимого типа"
                                            fileValidateTypeLabelExpectedTypes="Допустимы .odt, .docx, .doc, .docm, .pdf, .xlsx, .xls"
                                    />
                                </v-flex>
                            </v-layout>

                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="acceptClose">Отменить</v-btn>
                        <v-btn color="blue darken-1" flat @click="acceptSave(acceptBidItems.acceptComment)">Принять</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-if="this.role == 'ROLE_ADMIN' || this.role == 'ROLE_EXPERT'" v-model="rejectDialog" max-width="500px">
                <v-card>
                    <v-card-title>
                        <v-spacer></v-spacer>
                        <span class="headline" style="text-align: center">Отклонить заявку</span>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-alert
                            :value="rejectSuccessAlert"
                            dismissible
                            type="success"
                    >
                        {{rejectSuccessText}}
                    </v-alert>
                    <v-alert
                            :value="rejectErrorAlert"
                            color="error"
                            icon="warning"

                    >
                        {{rejectErrorText}}
                    </v-alert>

                    <v-card-text>
                        <v-container grid-list-md>

                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-textarea
                                            row="3"
                                            v-model="rejectBidItems.rejectComment"
                                            label="Kомментарий"
                                    ></v-textarea>
                                </v-flex>
                                <v-flex xs12>
                                    <file-pond
                                            ref="rejectFilespond"
                                            label-idle="Прикрепить файлы..."
                                            allow-multiple="true"
                                            :accepted-file-types="FileTypes"
                                            labelFileTypeNotAllowed="Файл недопустимого типа"
                                            fileValidateTypeLabelExpectedTypes="Допустимы .odt, .docx, .doc, .docm, .pdf, .xlsx, .xls"
                                    />
                                </v-flex>
                            </v-layout>

                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="rejectClose">Отменить</v-btn>
                        <v-btn color="blue darken-1" flat @click="rejectSave(rejectBidItems.rejectComment)">Отклонить</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-if="this.role == 'ROLE_ADMIN'" v-model="performerDialog" max-width="700px">
                <v-card>
                    <v-card-title>
                        <v-spacer></v-spacer>
                        <span class="headline">Назначить исполнителя</span>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-alert
                            :value="performerSuccessAlert"
                            dismissible
                            type="success"
                    >
                        {{performerSuccessText}}
                    </v-alert>
                    <v-alert
                            :value="performerErrorAlert"
                            color="error"
                            icon="warning"

                    >
                        {{performerErrorText}}
                    </v-alert>

                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout wrap>
                                <v-flex xs12>
                                    <v-select
                                            :items="requestSelectsData.performerUsers"
                                            item-text="name"
                                            item-value="id"
                                            no-data-text="Нет доступных для выбора"
                                            v-model="performerBidItems.authorityUserId"
                                            required
                                            :menu-props="{
                                              transition: 'scale-transition',
                                              offsetY: true,
                                            }"
                                    ></v-select>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="performerClose">Отменить</v-btn>
                        <v-btn color="blue darken-1" flat @click="performerSave">Назначить</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="pdfDialog" max-width="1024px">
                <v-card id="iframeContainer">
                </v-card>
            </v-dialog>
            <v-spacer></v-spacer>
            <v-menu
                    offset-y
                    :close-on-content-click="false"
                    transition="v-scale-transition"
                    bottom>
                <v-btn primary light slot="activator">
                    Столбцы
                </v-btn>
                <v-list v-if="role == 'ROLE_ADMIN' || role == 'ROLE_EXPERT'">
                    <div style="text-align: center">
                        <v-btn flat color="primary" @click="headerAllSelected"> Выбрать все</v-btn> <v-btn flat color="primary" @click="headerDefaultSelected"> По умолчанию</v-btn>
                    </div>

                    <v-divider></v-divider>
                    <v-list-tile v-for="(header,index) in headers" :key="index">
                        <v-list-tile-action>
                            <v-checkbox
                                    v-model="header.selected" color="primary" :value="header.selected"
                            ></v-checkbox>
                        </v-list-tile-action>
                        <v-list-tile-title>{{header.text}}</v-list-tile-title>
                    </v-list-tile>
                </v-list>

                <v-list v-else>

                    <div style="text-align: center">
                        <v-btn flat color="primary" @click="headerAllSelected"> Выбрать все</v-btn> <v-btn flat color="primary" @click="headerDefaultSelected"> По умолчанию</v-btn>
                    </div>

                    <v-divider></v-divider>

                    <v-list-tile v-for="(header,index) in headers2" :key="index">
                        <v-list-tile-action>
                            <v-checkbox
                                    v-model="header.selected" color="primary" :value="header.selected"
                            ></v-checkbox>
                        </v-list-tile-action>
                        <v-list-tile-title>{{header.text}}</v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>
            <v-btn color="info" dark class="mb-2" @click="refreshData">
                <i class="material-icons">
                    refresh
                </i>  Обновить
            </v-btn>
        </v-toolbar>
        <v-alert
                :value="deleteTextAlert"
                type="success"
                dismissible
        >
            {{deleteText}}
        </v-alert>

        <v-data-table
                :headers="filteredHeaders"
                :role="role"
                :items="filteredItems"
                :pagination.sync="pagination"
                :total-items="totalRequests"
                :loading="tableLoading"
                :light=true
                no-data-text=""
                no-results-text=""
                disable-initial-sort
                rows-per-page-text="Строк на странице"
                :rows-per-page-items='[ 15, 30, 50, { "text": "все", "value": -1 } ]'
                class="elevation-1 request-table"
        >
            <template slot="headers" slot-scope="props">
                <tr class="title-tr">
                    <th
                            v-for="header in props.headers"
                            :key="header.text"
                            :class="['column', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '', header.sortable !== false ? 'sortable' : '', header.editable ? 'editable-col' : '']"
                            @click="header.sortable !== false ? changeSort(header.value) : ''"
                    >
                        <v-icon small v-if="header.sortable !== false">arrow_upward</v-icon>
                        {{ header.text }}
                    </th>
                </tr>
                <tr class="grey lighten-3 filter-row filter-tr">
                    <th
                            v-for="header in props.headers"
                            :key="header.text"
                    >
                        <div v-if="requestFilters.hasOwnProperty(header.filter)">
                            <span v-if="header.date">
                                <v-menu
                                        v-model="requestSelectsData[header.dateMenuFrom]"
                                        class="filter-menu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        :return-value.sync="date"
                                        lazy
                                        transition="scale-transition"
                                        offset-y
                                        full-width
                                        min-width="290px"
                                >

                                    <v-text-field
                                            slot="activator"
                                            class="table-filter"
                                            label="Дата, от"
                                            solo
                                            clearable
                                            @click:clear="clearDate(header.filter)"
                                            :value="dateFormatted(requestFilters[header.filter])"
                                            validate-on-blur
                                            readonly
                                    >
                                    </v-text-field>

                                    <v-date-picker v-model="requestFilters[header.filter]" no-title @input="requestSelectsData[header.dateMenuFrom] = false" locale="ru"></v-date-picker>
                                </v-menu>
                                <v-menu
                                         v-model="requestSelectsData[header.dateMenuTo]"
                                         class="filter-menu"
                                         :close-on-content-click="false"
                                         :nudge-right="40"
                                         :return-value.sync="date"
                                         lazy
                                         transition="scale-transition"
                                         offset-y
                                         full-width
                                         min-width="290px"
                                 >

                                <v-text-field
                                        slot="activator"
                                        class="table-filter"
                                        label="Дата, до"
                                        solo
                                        clearable
                                        @click:clear="clearDate(header.dateMenuTo)"
                                        :value="dateFormatted(requestFilters[header.dateMenuTo])"
                                        validate-on-blur
                                        readonly
                                >
                                </v-text-field>

                                <v-date-picker v-model="requestFilters[header.dateMenuTo]" no-title @input="requestSelectsData[header.dateMenuTo] = false" locale="ru"></v-date-picker>
                            </v-menu>
                            </span>
                            <v-select
                                    v-else-if="header.boolean"
                                    v-model="requestFilters[header.filter]"
                                    :items="requestSelectsData.filterBoolean"
                                    class="table-filter"
                                    item-text="name"
                                    item-value="id"
                                    solo
                                    clearable
                                    :menu-props="{
                                          transition: 'scale-transition',
                                          offsetY: true,
                                        }"
                            ></v-select>
                            <v-select
                                    v-else-if="header.yearsFinancing"
                                    v-model="requestFilters[header.filter]"
                                    :items="yearsFinancing"
                                    class="table-filter multiple-select"
                                    multiple
                                    solo
                                    clearable
                                    :menu-props="{
                                          transition: 'scale-transition',
                                          offsetY: true,
                                        }"
                            ></v-select>
                            <v-text-field
                                    v-else-if="!header.select"
                                    v-model="requestFilters[header.filter]"
                                    class="table-filter"
                                    single-line
                                    solo
                                    :mask="header.number ? '###############' : ''"
                                    clearable
                                    hide-details
                            ></v-text-field>
                            <v-autocomplete
                                    v-else
                                    v-model="requestFilters[header.filter]"
                                    :items="((role == 'ROLE_ADMIN' || role == 'ROLE_EXPERT') && header.filter == 'contains_status') ? requestSelectsData[header.selectNameAdmin] : requestSelectsData[header.selectName]"
                                    :class="[header.multiple ? 'multiple-select' : 'filter-select', 'table-filter']"
                                    item-text="name"
                                    item-value="id"
                                    solo
                                    clearable
                                    hint
                                    no-data-text="Нет доступных для выбора"
                                    :multiple="header.multiple"
                                    :menu-props="{
                                          transition: 'scale-transition',
                                          offsetY: true,
                                        }"
                            ></v-autocomplete>
                        </div>
                    </th>
                </tr>
            </template>

            <template slot="items" slot-scope="props">
                <td :class="[props.item.notStatus ? 'new-request-row' : '']" v-if="showColumn('sort_id')" @dblclick="request_info(props.item)">{{ props.item.id }}</td>
                <td :class="[props.item.notStatus ? 'new-request-row' : '']" v-if="showColumn('requestType')" @dblclick="request_info(props.item)">{{ props.item.requestType }}</td>
                <td :class="[props.item.notStatus ? 'new-request-row' : '']" v-if="showColumn('sort_date_of_admission_to_wg')" @dblclick="request_info(props.item)">{{ dateFormatted(props.item.dateOfAdmissionToWG) }}</td>
                <td :class="[props.item.notStatus ? 'new-request-row' : '']" v-if="(role == 'ROLE_ADMIN' || role == 'ROLE_EXPERT') && showColumn('sort_customer_name')"  @dblclick="request_info(props.item)" style="min-width: 350px;">{{ props.item.customerName }}</td>
                <td :class="[props.item.notStatus ? 'new-request-row' : '']" v-if="(role == 'ROLE_ADMIN' || role == 'ROLE_EXPERT') && showColumn('sort_authority_user_name')"  @dblclick="request_info(props.item)">{{ props.item.authorityUser }}</td>
                <td :class="[props.item.notStatus ? 'new-request-row' : '']" v-if="showColumn('sort_contract_name')" @dblclick="request_info(props.item)" style="min-width: 250px;">{{ props.item.requestName }}</td>
                <td :class="[props.item.notStatus ? 'new-request-row' : '']" v-if="showColumn('status2')" @dblclick="request_info(props.item)">
                    <v-edit-dialog
                            v-if="(role == 'ROLE_ADMIN' || role == 'ROLE_EXPERT') &&(props.item.status == 'APPROVED' || props.item.status == 'PUBLISHED' || props.item.status == 'COMMISSION_WORK')"
                            large
                            lazy
                            cancelText="Отменить"
                            saveText="Сохранить"
                            @save="saveUpdateStatus(props.item,statusType)"
                    >
                        <div>{{ props.item.status2 }} </div>
                        <template v-slot:input>
                            <div class="mt-3 title">Статус</div>
                            <v-select
                                    v-model="statusType"
                                    :items="props.item.status == 'APPROVED' ? statusItems1 : props.item.status == 'PUBLISHED' ? statusItems2 : props.item.status == 'COMMISSION_WORK' ? statusItems3 : []"
                                    item-text="name"
                                    item-value="val"
                                    :menu-props="{
                                          transition: 'scale-transition',
                                          offsetY: true,
                                        }"
                            ></v-select>
                        </template>
                    </v-edit-dialog>
                    <span v-else>{{ props.item.status2 }}</span>

                </td>
                <td :class="[props.item.notStatus ? 'new-request-row' : '']" v-if="showColumn('sort_date_of_publication')" @dblclick="request_info(props.item)">
                    <v-edit-dialog
                            v-if="role == 'ROLE_ADMIN' || role == 'ROLE_EXPERT'"
                            large
                            lazy
                            cancelText="Отменить"
                            saveText="Сохранить"
                            @save="saveUpdate(props.item,'dateOfPublication',props.item.dateOfPublication)"
                    >
                        <div>{{ dateFormatted(props.item.dateOfPublication) }} </div>
                        <template v-slot:input>
                            <div class="mt-3 title date-column-title">Дата публикации</div>
                            <v-date-picker v-model="props.item.dateOfPublication" no-title locale="ru" class="column-picker"></v-date-picker>
                        </template>
                    </v-edit-dialog>
                    <span v-else>{{ dateFormatted(props.item.dateOfPublication) }}</span>

                </td>
                <td :class="[props.item.notStatus ? 'new-request-row' : '']" v-if="showColumn('sort_date_of_admission_bids_deadline')" @dblclick="request_info(props.item)">
                    <v-edit-dialog
                            v-if="role == 'ROLE_ADMIN' || role == 'ROLE_EXPERT'"
                            large
                            lazy
                            cancelText="Отменить"
                            saveText="Сохранить"
                            @save="saveUpdate(props.item,'dateOfAdmissionBidsDeadline',props.item.dateOfAdmissionBidsDeadline)"
                    >
                        <div>{{ dateFormatted(props.item.dateOfAdmissionBidsDeadline) }} </div>
                        <template v-slot:input>
                            <div class="mt-3 title date-column-title">Дата окончания подачи заявок</div>
                            <v-date-picker v-model="props.item.dateOfAdmissionBidsDeadline" no-title locale="ru" class="column-picker"></v-date-picker>
                        </template>
                    </v-edit-dialog>
                    <span v-else>{{dateFormatted(props.item.dateOfAdmissionBidsDeadline)}}</span>
                </td>
                <td :class="[props.item.notStatus ? 'new-request-row' : '']" v-if="showColumn('sort_date_of_auction')" @dblclick="request_info(props.item)">
                    <v-edit-dialog
                            v-if="role == 'ROLE_ADMIN' || role == 'ROLE_EXPERT'"
                            large
                            lazy
                            cancelText="Отменить"
                            saveText="Сохранить"
                            @save="saveUpdate(props.item,'dateOfAuction', props.item.dateOfAuction)"
                    >
                        <div>{{ dateFormatted(props.item.dateOfAuction) }} </div>
                        <template v-slot:input>
                            <div class="mt-3 title date-column-title"> Дата аукциона </div>
                            <v-date-picker v-model="props.item.dateOfAuction" no-title locale="ru" class="column-picker"></v-date-picker>
                        </template>
                    </v-edit-dialog>
                    <span v-else>{{dateFormatted(props.item.dateOfAuction)}}</span>
                </td>
                <td :class="[props.item.notStatus ? 'new-request-row' : '']" v-if="showColumn('contains_years_of_financing')" @dblclick="request_info(props.item)" style="min-width: 180px;">
                        <span v-for="(item,index) in props.item.yearsOfFinancing" :key="index">
                             {{ item }}{{ index == props.item.yearsOfFinancing.length - 1 ? '' : ', ' }}
                        </span>
                </td>
                <td :class="[props.item.notStatus ? 'new-request-row' : '']" v-if="(role == 'ROLE_ADMIN' || role == 'ROLE_EXPERT') && showColumn('sort_notice_reg_number')" @dblclick="request_info(props.item)">
                    <v-edit-dialog
                            v-if="role == 'ROLE_ADMIN' || role == 'ROLE_EXPERT'"
                            large
                            lazy
                            cancelText="Отменить"
                            saveText="Сохранить"
                            @save="saveUpdate(props.item,'noticeRegNumber',props.item.noticeRegNumber)"
                    >
                        <div>{{ props.item.noticeRegNumber }} </div>
                        <template v-slot:input>
                            <div class="mt-3 title">Реестровый номер извещения</div>
                            <v-text-field
                                    v-model="props.item.noticeRegNumber"
                                    single-line
                                    autofocus
                            ></v-text-field>
                        </template>
                    </v-edit-dialog>
                    <span v-else>{{ props.item.noticeRegNumber }}</span>
                </td>
                <td :class="[props.item.notStatus ? 'new-request-row' : '']" v-if="showColumn('sort_start_contract_price')" @dblclick="request_info(props.item)" style="min-width: 120px;">{{props.item.startContractPrice}}</td>
                <td :class="[props.item.notStatus ? 'new-request-row' : '']" v-if="showColumn('sort_bid_price')" @dblclick="request_info(props.item)">
                    <v-edit-dialog
                            v-if="role == 'ROLE_ADMIN' || role == 'ROLE_EXPERT'"
                            large
                            lazy
                            cancelText="Отменить"
                            saveText="Сохранить"
                            @save="saveUpdate(props.item,'bidPrice',props.item.bidPrice)"
                    >
                        <div>{{ priceFormat(props.item.bidPrice) }} </div>
                        <template v-slot:input>
                            <div class="mt-3 title">Цена по итогам торгов</div>
                            <v-text-field
                                    v-model="props.item.bidPrice"
                                    @keypress="onlyForCurrency($event, props.item.bidPrice)"
                                    single-line
                                    autofocus
                            ></v-text-field>
                        </template>
                    </v-edit-dialog>
                    <span v-else>{{ priceFormat(props.item.bidPrice) }}</span>
                </td>
                <td :class="[props.item.notStatus ? 'new-request-row' : '']" v-if="showColumn('sort_date_of_review')" @dblclick="request_info(props.item)">
                    <v-edit-dialog
                            v-if="role == 'ROLE_ADMIN' || role == 'ROLE_EXPERT'"
                            large
                            lazy
                            cancelText="Отменить"
                            saveText="Сохранить"
                            @save="saveUpdate(props.item,'dateOfReview',props.item.dateOfReview)"
                    >
                        <div>{{ dateFormatted(props.item.dateOfReview) }} </div>
                        <template v-slot:input>
                            <div class="mt-3 title date-column-title">Дата подведения итогов</div>
                            <v-date-picker v-model="props.item.dateOfReview" no-title locale="ru" class="column-picker"></v-date-picker>
                        </template>
                    </v-edit-dialog>
                    <span v-else>{{ dateFormatted(props.item.dateOfReview) }}</span>
                </td>
                <td :class="[props.item.notStatus ? 'new-request-row' : '']" v-if="showColumn('sort_saved_money')" @dblclick="request_info(props.item)"> {{ priceFormat(props.item.savedMoney) }}</td>
                <td :class="[props.item.notStatus ? 'new-request-row' : '']" v-if="showColumn('sort_number_of_participants')" @dblclick="request_info(props.item)">
                    <v-edit-dialog
                            v-if="role == 'ROLE_ADMIN' || role == 'ROLE_EXPERT'"
                            large
                            lazy
                            cancelText="Отменить"
                            saveText="Сохранить"
                            @save="saveUpdate(props.item,'numberOfParticipants',props.item.numberOfParticipants)"
                    >
                        <div>{{ props.item.numberOfParticipants }} </div>
                        <template v-slot:input>
                            <div class="mt-3 title">Кол-во участников</div>
                            <v-text-field
                                    v-model="props.item.numberOfParticipants"
                                    type="number"
                                    single-line
                                    autofocus
                            ></v-text-field>
                        </template>
                    </v-edit-dialog>
                    <span v-else>{{ props.item.numberOfParticipants }}</span>
                </td>
                <td :class="[props.item.notStatus ? 'new-request-row' : '']" v-if="showColumn('sort_initial_number_of_allowed')">
                    <v-edit-dialog
                            v-if="role == 'ROLE_ADMIN' || role == 'ROLE_EXPERT'"
                            large
                            lazy
                            cancelText="Отменить"
                            saveText="Сохранить"
                            @save="saveUpdate(props.item,'initialNumberOfAllowed',props.item.initialNumberOfAllowed)"
                    >
                        <div v-if="props.item.initialNumberOfAllowed"> {{ props.item.initialNumberOfAllowed}} </div>
                        <template v-slot:input>
                            <div class="mt-3 title">Кол-во допущенных (1 протокол)</div>
                            <v-text-field
                                    v-model="props.item.initialNumberOfAllowed"
                                    type="number"
                                    single-line
                                    autofocus
                            ></v-text-field>
                        </template>
                    </v-edit-dialog>
                    <span v-else>
                         <span v-if="props.item.initialNumberOfAllowed">{{ props.item.initialNumberOfAllowed}}</span>
                    </span>
                </td>
                <td :class="[props.item.notStatus ? 'new-request-row' : '']" v-if="showColumn('sort_final_number_of_allowed')">
                    <v-edit-dialog
                            v-if="role == 'ROLE_ADMIN' || role == 'ROLE_EXPERT'"
                            large
                            lazy
                            cancelText="Отменить"
                            saveText="Сохранить"
                            @save="saveUpdate(props.item,'finalNumberOfAllowed',props.item.finalNumberOfAllowed)"
                    >
                        <div v-if="props.item.finalNumberOfAllowed"> {{ props.item.finalNumberOfAllowed}} </div>
                        <template v-slot:input>
                            <div class="mt-3 title">Кол-во допущенных (итоговый протокол)</div>
                            <v-text-field
                                    v-model="props.item.finalNumberOfAllowed"
                                    type="number"
                                    single-line
                                    autofocus
                            ></v-text-field>
                        </template>
                    </v-edit-dialog>
                    <span v-else>
                         <span v-if="props.item.finalNumberOfAllowed">{{ props.item.finalNumberOfAllowed}}</span>
                    </span>
                </td>
                <td :class="[props.item.notStatus ? 'new-request-row' : '']" v-if="showColumn('didNotTakePlace')" @dblclick="request_info(props.item)">
                    <v-edit-dialog
                            v-if="role == 'ROLE_ADMIN' || role == 'ROLE_EXPERT'"
                            large
                            lazy
                            cancelText="Отменить"
                            saveText="Сохранить"
                            @save="saveUpdate(props.item,'didNotTakePlace',props.item.didNotTakePlace)"
                    >
                        <div v-if="props.item.didNotTakePlace"> <v-icon color="green darken-2">check</v-icon></div>
                        <template v-slot:input>
                            <div class="mt-3 title">Не состоялся</div>
                            <v-checkbox v-model="props.item.didNotTakePlace" color="primary" ></v-checkbox>
                        </template>
                    </v-edit-dialog>
                    <span v-else> <v-icon v-if="props.item.didNotTakePlace" color="green darken-2">check</v-icon></span>
                </td>
                <td :class="[props.item.notStatus ? 'new-request-row' : '']" v-if="(role == 'ROLE_ADMIN' || role == 'ROLE_EXPERT') && showColumn('cmp')" @dblclick="request_info(props.item)"> <span v-if="props.item.definitionCustomerPart"><v-icon color="green darken-2">check</v-icon></span></td>
                <td :class="[props.item.notStatus ? 'new-request-row' : '']" v-if="showColumn('sort_attraction_amount')" @dblclick="request_info(props.item)"><span v-if="!props.item.definitionCustomerPart && props.item.requirementForParticipant && props.item.attractionPercent">{{ priceFormat(props.item.attractionAmount) }} ({{props.item.attractionPercent}} % от НМЦ) </span></td>
                <td :class="[props.item.notStatus ? 'new-request-row' : '']" v-if="(role == 'ROLE_ADMIN' || role == 'ROLE_EXPERT') && showColumn('disabledPeopleOrgPart')" @dblclick="request_info(props.item)"> <span v-if="props.item.disabledPeopleOrgPart"><v-icon color="green darken-2">check</v-icon></span></td>
                <td :class="[props.item.notStatus ? 'new-request-row' : '']" v-if="(role == 'ROLE_ADMIN' || role == 'ROLE_EXPERT') && showColumn('penalSystemPart')" @dblclick="request_info(props.item)"> <span v-if="props.item.penalSystemPart"><v-icon color="green darken-2">check</v-icon></span></td>
                <td :class="[props.item.notStatus ? 'new-request-row' : '']" v-if="(role == 'ROLE_ADMIN' || role == 'ROLE_EXPERT') && showColumn('sort_winner')" @dblclick="request_info(props.item)">
                    <v-edit-dialog
                            large
                            lazy
                            cancelText="Отменить"
                            saveText="Сохранить"
                            @save="saveUpdate(props.item,'winner',props.item.winner)"
                    >
                        <div>{{ props.item.winner }} </div>
                        <template v-slot:input>
                            <div class="mt-3 title">Победитель</div>
                            <v-textarea
                                    rows="1"
                                    v-model="props.item.winner"
                                    :rules="props.item.winner ? requiredRules1024 : []"
                                    maxlength="1024"
                                    autofocus
                            >
                            </v-textarea>
                        </template>
                    </v-edit-dialog>
                </td>
                <td :class="[props.item.notStatus ? 'new-request-row' : '', 'action-buttons justify-center actions-block']" v-if="showColumn('actions')">

                    <v-flex uu-actions v-if="role == 'ROLE_ADMIN' || role == 'ROLE_EXPERT'">
                        <v-layout row>
                            <v-flex xs-2>
                                <v-tooltip v-if="props.item.status == 'ASSIGNED' || props.item.status == 'SEND_AFTER_REWORK'" top>
                                    <v-btn slot="activator" color="warning" flat icon @click="revisionBid(props.item)">
                                        <v-icon small>fa-paper-plane</v-icon>
                                    </v-btn>
                                    <span>Отправить на доработку</span>
                                </v-tooltip>
                            </v-flex>
                            <v-flex xs-2>
                                <v-tooltip v-if="props.item.status == 'ASSIGNED' || props.item.status == 'SEND_AFTER_REWORK'" top>
                                    <v-btn slot="activator" color="success" flat icon @click="acceptBid(props.item)">
                                        <v-icon small>fa-check-circle-o</v-icon>
                                    </v-btn>
                                    <span>Принять заявку</span>
                                </v-tooltip>
                            </v-flex>
                            <v-flex xs-2>
                                <v-tooltip v-if="props.item.status == 'ASSIGNED' || props.item.status == 'SEND_AFTER_REWORK'" top>
                                    <v-btn slot="activator" color="error" flat icon @click="rejectBid(props.item)">
                                        <v-icon small>fa-times-circle-o</v-icon>
                                    </v-btn>
                                    <span>Отклонить заявку</span>
                                </v-tooltip>
                            </v-flex>
                            <v-flex v-if="role == 'ROLE_ADMIN'" xs-2>
                                <v-tooltip v-if="!(props.item.status == 'CANCELED' || props.item.status == 'WITHDRAWN'  || props.item.status == 'SUPPLIER_DEFINITION_COMPLETED'  || props.item.status == 'SUPPLIER_DEFINITION_CANCELED')" top>
                                    <v-btn slot="activator" color="cyan" flat icon @click="performerBid(props.item)">
                                        <v-icon small>fa-user-plus</v-icon>
                                    </v-btn>
                                    <span>Назначить на исполнение</span>
                                </v-tooltip>
                            </v-flex>
                            <v-flex xs-2>
                                <v-tooltip top>
                                    <v-btn slot="activator" color="red" flat icon @click="pdfRequest(props.item)" :loading="pdfLoading == props.item.id ? true : false">
                                        <v-icon small>fa-file-pdf-o</v-icon>
                                    </v-btn>
                                    <span>Выгрузка в PDF</span>
                                </v-tooltip>
                            </v-flex>
                            <v-flex xs-2>
                                <v-tooltip top>
                                    <v-btn slot="activator" color="success" flat icon @click="uploadArchive(props.item.id)" :loading="loading == props.item.id ? true : false">
                                        <v-icon small>fa-download</v-icon>
                                    </v-btn>
                                    <span>Выгрузка документов архивом</span>
                                </v-tooltip>
                            </v-flex>
                            <v-flex xs-2>
                                <v-tooltip top>
                                    <v-btn slot="activator" :color="props.item.notStatus ? 'orange' : 'primary'" flat icon @click="request_info(props.item)">
                                        <v-icon v-if="props.item.notStatus" small>fa-bell</v-icon>
                                        <v-icon v-else small> fa-ellipsis-v </v-icon>
                                    </v-btn>
                                    <span v-if="props.item.notStatus">Непросмотренные изменения</span>
                                    <span v-else>Посмотреть</span>
                                </v-tooltip>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs-12 customer-actions v-else>
                        <v-layout row>
                            <v-flex xs-2></v-flex>
                            <v-flex xs-2>
                                <v-tooltip v-if="props.item.changeStatus" top>
                                    <v-btn slot="activator" color="error" flat icon class="request-change">
                                        <v-icon small>fa-exclamation-triangle</v-icon>
                                    </v-btn>
                                    <span>Несохраненные изменения</span>
                                </v-tooltip>
                            </v-flex>
                            <v-flex xs-2>
                                <v-tooltip top>
                                    <v-btn slot="activator" color="red" flat icon @click="pdfRequest(props.item)" :loading="pdfLoading == props.item.id ? true : false">
                                        <v-icon small>fa-file-pdf-o</v-icon>
                                    </v-btn>
                                    <span>Выгрузка в PDF</span>
                                </v-tooltip>
                            </v-flex>
                            <v-flex xs-2>
                                <v-tooltip v-if="props.item.status == 'SEND_AFTER_CREATE' || props.item.status == 'ASSIGNED' || props.item.status == 'ON_REWORK' || props.item.status == 'SEND_AFTER_REWORK' || props.item.status == 'APPROVED'" top>
                                    <v-btn slot="activator" color="error" flat icon @click="withdrawBid(props.item)">
                                        <v-icon small>fa-undo</v-icon>
                                    </v-btn>
                                    <span>Отозвать заявку</span>
                                </v-tooltip>
                            </v-flex>
                            <v-flex xs-2>
                                <v-tooltip v-if="props.item.status == 'CREATED' || props.item.status == 'ON_REWORK'" top>
                                    <v-btn slot="activator" color="warning" flat icon @click="sendBid(props.item)">
                                        <v-icon small>fa-paper-plane</v-icon>
                                    </v-btn>
                                    <span>Отправить заявку</span>
                                </v-tooltip>
                            </v-flex>
                            <v-flex xs-2>
                                <v-tooltip top>
                                    <v-btn slot="activator" :color="props.item.notStatus ? 'orange' : 'primary'" flat icon @click="request_info(props.item)">
                                        <v-icon v-if="props.item.notStatus" small>fa-bell</v-icon>
                                        <v-icon v-else small>fa-pencil</v-icon>
                                    </v-btn>
                                    <span v-if="props.item.notStatus">Непросмотренные изменения</span>
                                    <span v-else>Редактировать заявку</span>
                                </v-tooltip>
                            </v-flex>
                        </v-layout>
                    </v-flex>


                    <!--<v-tooltip v-if="this.role == 'ROLE_CUSTOMER_ADMIN' || this.role == 'ROLE_CUSTOMER_WORKER'" top>-->
                        <!--<v-btn slot="activator" color="red" flat icon @click="deleteItem(props.item)">-->
                            <!--<v-icon small>delete</v-icon>-->
                        <!--</v-btn>-->
                        <!--<span>Delete заявку</span>-->
                    <!--</v-tooltip>-->

                </td>
            </template>

        </v-data-table>

        <div class="text-xs-center pt-2">
            <v-pagination v-model="pagination.page" :total-visible="7" :length="pages"></v-pagination>
        </div>

        <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
            {{ snackText }}
        </v-snackbar>

    </v-container>
</template>
<script>

    import Vue from 'vue'

    import axios from 'axios'

    // Import Vue FilePond
    import vueFilePond from 'vue-filepond';

    // Import plugins
    import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js';

    // Import FilePond styles
    import 'filepond/dist/filepond.min.css';

    // Create component
    const FilePond = vueFilePond(FilePondPluginFileValidateType);

    import { UpdateNote } from '../main.js';

    import Excel from 'exceljs/dist/es5/exceljs.browser.js';

    import { WidthType, Document, Packer, Paragraph, BorderStyle} from "docx";

    import { saveAs } from 'file-saver';

    import pdfMake from "pdfmake/build/pdfmake";
    import pdfFonts from "pdfmake/build/vfs_fonts";
    pdfMake.vfs = pdfFonts.pdfMake.vfs;

    export default{
        components: {
            FilePond
        },

        data: () => ({
            backUrl: null,
            pdfDialog: false,
            excelLoading: false,
            statusOnCreated: false,
            totalRequests: 0,
            statusType: '',
            date: '',
            revisionFilesArr: [],
            sendFilesArr: [],
            wordDialog: false,
            wordErrorAlert: false,
            wordErrorText: false,
            startDateWord: null,
            endDateWord: null,
            snack: false,
            snackColor: '',
            snackText: '',

            notSavedRequests:{
                status: false
            },
            unsavedRequestKeys: [],
            loading: false,
            pdfLoading: false,
            tableLoading: true,
            valid: true,
            requiredRulesComment512: [
                v => v.length <= 512 || 'Должно быть не более 512 символов'
            ],
            requiredRules: [
                v => !!v || 'Значение должно быть заполнено',
            ],
            requests: [],
            notInfo: [],
            error_text: '',
            errorAlert:false,
            dialog: false,
            sendDialog: false,
            acceptDialog: false,
            revisionDialog: false,
            withdrawDialog: false,
            rejectDialog: false,
            performerDialog: false,

            headers: [
                { text: 'Номер заявки', excelVal: 'id',value: 'sort_id',filter: 'eq_id',selected: true, number: true},
                { text: 'Тип', excelVal: 'requestType',value: 'requestType',selected: true, filter: 'contains_supplier_definition_type', select: true, selectName: 'filterRequestType', sortable: false, multiple: true},
                { text: 'Поступление на РГ', excelVal: 'dateOfAdmissionToWG',value: 'sort_date_of_admission_to_wg', filter: 'eq_date_of_admission_to_wg_from', date: true, dateMenuFrom: 'date_of_admission_to_wg', dateMenuTo: 'eq_date_of_admission_to_wg_to', selected: true},
                { text: 'Заказчик', excelVal: 'customerName',value: 'sort_customer_name',filter: 'contains_customer_id', select: true, selectName: 'customersList', selected: true, multiple: true},
                { text: 'Исполнитель', excelVal: 'authorityUser',value: 'sort_authority_user_name', filter: 'contains_authority_user_id', select: true, selectName: 'performerUsers',selected: true, multiple: true},
                { text: 'Предмет лота', excelVal: 'requestName',value: 'sort_contract_name',filter: 'like_contract_name',selected: true},
                { text: 'Статус', excelVal: 'status2', value: 'status2',filter: 'contains_status', select: true, selectNameAdmin: 'filterRequestStatusForAdmin', selectName: 'filterRequestStatusForCustomer', selected: true, sortable: false, multiple: true},
                { text: 'Дата публикации', excelVal: 'dateOfPublication', value: 'sort_date_of_publication',filter: 'eq_date_of_publication_from', editable: true, date: true, dateMenuFrom: 'date_of_publication', dateMenuTo: 'eq_date_of_publication_to'},
                { text: 'Дата окончания подачи заявок', excelVal: 'dateOfAdmissionBidsDeadline', value: 'sort_date_of_admission_bids_deadline',filter: 'eq_date_of_admission_bids_deadline_from', editable: true, date: true, dateMenuFrom: 'date_of_admission_bids_deadline', dateMenuTo: 'eq_date_of_admission_bids_deadline_to'},
                { text: 'Дата аукциона', excelVal: 'dateOfAuction', value: 'sort_date_of_auction',filter: 'eq_date_of_auction_from', editable: true, date: true, dateMenuFrom: 'eq_date_of_auction_from', dateMenuTo: 'eq_date_of_auction_to'},
                { text: 'Год финансирования', excelVal: 'yearsOfFinancing', value: 'contains_years_of_financing',filter: 'contains_years_of_financing', yearsFinancing: true, sortable: false},
                { text: 'Реестровый номер извещения', excelVal: 'noticeRegNumber', value: 'sort_notice_reg_number',filter: 'like_notice_reg_number', editable: true},
                { text: 'НМЦ', excelVal: 'startContractPrice', value: 'sort_start_contract_price',filter: 'eq_start_contract_price',selected: true},
                { text: 'Цена по итогам торгов', excelVal: 'bidPrice', value: 'sort_bid_price',filter: 'eq_bid_price', editable: true},
                { text: 'Дата подведения итогов', excelVal: 'dateOfReview', filter: 'eq_date_of_review_from', value: 'sort_date_of_review', editable: true, date: true, dateMenuFrom: 'date_of_review', dateMenuTo: 'eq_date_of_review_to' },
                { text: 'Экономия', excelVal: 'savedMoney', filter: 'eq_saved_money', value: 'sort_saved_money' },
                { text: 'Кол-во участников', excelVal: 'numberOfParticipants', filter: 'eq_number_of_participants', value: 'sort_number_of_participants', number: true , editable: true },
                { text: 'Кол-во допущенных (1 протокол)', excelVal: 'protocol1',filter: 'eq_initial_number_of_allowed', value: 'sort_initial_number_of_allowed', editable: true, number: true},
                { text: 'Кол-во допущенных (итоговый протокол)', excelVal: 'protocol2',filter: 'eq_final_number_of_allowed', value: 'sort_final_number_of_allowed', editable: true, number: true },
                { text: 'Не состоялся', excelVal: 'didNotTakePlace', filter: 'eq_did_not_take_place', value: 'didNotTakePlace', editable: true,boolean: true, sortable: false},
                { text: 'СМП', excelVal: 'cmp', value: 'cmp' ,filter: 'eq_definition_customer_part',boolean: true, sortable: false},
                { text: 'Сумма привлечения СМП', excelVal: 'attractionAmount', filter: 'eq_attraction_amount', value: 'sort_attraction_amount'},
                { text: 'Инвалиды', excelVal: 'disabledPeopleOrgPart', filter: 'eq_disabled_people_org_part', value: 'disabledPeopleOrgPart',boolean: true, sortable: false},
                { text: 'УИС', excelVal: 'penalSystemPart', filter: 'eq_penal_system_part', value: 'penalSystemPart',boolean: true, sortable: false },
                { text: 'Победитель', excelVal: 'winner', filter: 'like_winner', value: 'sort_winner', editable: true},
                { text: 'Действия', value: 'actions',align: 'center',class: 'flight-actions',selected: true, sortable: false }
            ],
            headers2: [
                { text: 'Номер заявки', excelVal: 'id',value: 'sort_id',filter: 'eq_id',selected: true, number: true},
                { text: 'Тип', excelVal: 'requestType',value: 'requestType',selected: true, filter: 'contains_supplier_definition_type', select: true, selectName: 'filterRequestType', sortable: false, multiple: true},
                { text: 'Поступление в УУ', excelVal: 'dateOfAdmissionToWG',value: 'sort_date_of_admission_to_wg', filter: 'eq_date_of_admission_to_wg_from', date: true, dateMenuFrom: 'date_of_admission_to_wg', dateMenuTo: 'eq_date_of_admission_to_wg_to', selected: true},
                { text: 'Предмет лота', excelVal: 'requestName',value: 'sort_contract_name',filter: 'like_contract_name',selected: true},
                { text: 'Статус', excelVal: 'status2', value: 'status2',filter: 'contains_status', select: true, selectNameAdmin: 'filterRequestStatusForAdmin', selectName: 'filterRequestStatusForCustomer', selected: true, sortable: false, multiple: true},
                { text: 'Дата публикации', excelVal: 'dateOfPublication', value: 'sort_date_of_publication',filter: 'eq_date_of_publication_from', editable: true, date: true, dateMenuFrom: 'date_of_publication', dateMenuTo: 'eq_date_of_publication_to'},
                { text: 'Дата окончания подачи заявок', excelVal: 'dateOfAdmissionBidsDeadline', value: 'sort_date_of_admission_bids_deadline',filter: 'eq_date_of_admission_bids_deadline_from', editable: true, date: true, dateMenuFrom: 'date_of_admission_bids_deadline', dateMenuTo: 'eq_date_of_admission_bids_deadline_to'},
                { text: 'Дата аукциона', excelVal: 'dateOfAuction', value: 'sort_date_of_auction',filter: 'eq_date_of_auction_from', editable: true, date: true, dateMenuFrom: 'eq_date_of_auction_from', dateMenuTo: 'eq_date_of_auction_to'},
                { text: 'Год финансирования', excelVal: 'yearsOfFinancing', value: 'contains_years_of_financing',filter: 'contains_years_of_financing', editable: true, yearsFinancing: true, sortable: false},
                { text: 'НМЦ', excelVal: 'startContractPrice', value: 'sort_start_contract_price',filter: 'eq_start_contract_price',selected: true},
                { text: 'Цена по итогам торгов', excelVal: 'bidPrice', value: 'sort_bid_price',filter: 'eq_bid_price', editable: true},
                { text: 'Дата подведения итогов', excelVal: 'dateOfReview', filter: 'eq_date_of_review_from', value: 'sort_date_of_review', editable: true, date: true, dateMenuFrom: 'date_of_review', dateMenuTo: 'eq_date_of_review_to' },
                { text: 'Экономия', excelVal: 'savedMoney', filter: 'eq_saved_money', value: 'sort_saved_money' },
                { text: 'Кол-во участников', excelVal: 'numberOfParticipants', filter: 'eq_number_of_participants', value: 'sort_number_of_participants', number: true , editable: true },
                { text: 'Кол-во допущенных (1 протокол)', excelVal: 'protocol1',filter: 'eq_initial_number_of_allowed', value: 'sort_initial_number_of_allowed', editable: true, number: true},
                { text: 'Кол-во допущенных (итоговый протокол)', excelVal: 'protocol2',filter: 'eq_final_number_of_allowed', value: 'sort_final_number_of_allowed', editable: true, number: true },
                { text: 'Не состоялся', excelVal: 'didNotTakePlace', filter: 'eq_did_not_take_place', value: 'didNotTakePlace', editable: true,boolean: true, sortable: false},
                { text: 'Сумма привлечения СМП', excelVal: 'attractionAmount', filter: 'eq_attraction_amount', value: 'sort_attraction_amount'},
                { text: 'Действия', excelVal: '', value: 'actions',align: 'center',class: 'flight-actions',selected: true, sortable: false }
            ],
            requestFilters: {
                eq_id: '',
                contains_supplier_definition_type: null,
                eq_date_of_admission_to_wg_from: null,
                eq_date_of_admission_to_wg_to: null,
                eq_customer_id: null,
                contains_customer_id: null,
                contains_authority_user_id: null,
                like_authority_user_name: null,
                like_contract_name: null,
                contains_status: null,
                eq_date_of_publication_from: null,
                eq_date_of_publication_to: null,
                eq_date_of_admission_bids_deadline_from: null,
                eq_date_of_admission_bids_deadline_to: null,
                eq_start_contract_price: null,
                like_notice_reg_number: null,
                contains_years_of_financing: null,
                eq_bid_price: null,
                eq_date_of_auction_from: null,
                eq_date_of_auction_to: null,
                eq_date_of_review_from: null,
                eq_date_of_review_to: null,
                eq_saved_money: null,
                eq_number_of_participants: '',
                eq_initial_number_of_allowed: '',
                eq_final_number_of_allowed: '',
                eq_did_not_take_place: null,
                eq_definition_customer_part: null,
                eq_attraction_amount: null,
                eq_attraction_percent: null,
                eq_disabled_people_org_part: null,
                eq_penal_system_part: null,
                like_winner: null,
                eq_customer_user_id: null,
                like_customer_user_name: null,
                eq_type: null,
            },
            pagination: {},
            editedIndex: -1,
            search: '',
            inputErrors:[],
            requiredRules1024: [
                v => !!v || 'Значение должно быть заполнено',
                v => v.length <= 1024 || 'Должно быть не более 1024 символов'
            ],
            statusItems1: [
                {
                    name: "Опубликовано",
                    val: "PUBLISHED"
                }
            ],
            statusItems2: [
                {
                    name: "Работа комиссии",
                    val: "COMMISSION_WORK"
                },
                {
                    name: "Определение поставщика отменено",
                    val: "SUPPLIER_DEFINITION_CANCELED"
                }
            ],
            statusItems3: [
                {
                    name: "Определение поставщика завершено",
                    val: "SUPPLIER_DEFINITION_COMPLETED"
                },

            ],

            withdrawSuccessText: '',
            withdrawSuccessAlert: false,
            withdrawErrorText: '',
            withdrawErrorAlert: false,

            performerSuccessText: '',
            performerSuccessAlert: false,
            performerErrorText: '',
            performerErrorAlert: false,

            rejectSuccessText: '',
            rejectSuccessAlert: false,
            rejectErrorText: '',
            rejectErrorAlert: false,

            acceptSuccessText: '',
            acceptSuccessAlert: false,
            acceptErrorText: '',
            acceptErrorAlert: false,

            revisionSuccessText: '',
            revisionSuccessAlert: false,
            revisionErrorText: '',
            revisionErrorAlert: false,

            deleteText:'',
            sendErrorAlert: false,
            sendSuccessAlert: false,
            deleteTextAlert: false,
            successAlert:false,
            sendSuccessText:'',
            sendErrorText:'',
            successText:'',
            performerBidItems: {
                id: '',
                uuid: '',
            },
            acceptBidItems: {
                id: '',
                uuid: '',
                acceptComment: '',

            },
            rejectBidItems: {
                id: '',
                uuid: '',
                rejectComment: '',
            },
            withdrawBidItems: {
                status: '',
                id: '',
                uuid: '',
                withdrawComment: '',

            },
            sendBidItems: {
                id: '',
                uuid: '',
                comment: '',
            },
            revisionBidItems: {
                id: '',
                uuid: '',
                revisionComment: '',
            },
            editedItem: {
                id: '',
                uuid: '',
                customerDefinition: '',
                purchaseId:'',
                startContractPrice:'',
                otherTaxInPrice:'',
                startServicePrice:'',
                financeSource:'',
                provisionSize:'',
                accountDetailsId:'',
                contractConditionsCanBeChanged:'',
                FZ_44:'',
                contractInfo:'',
                unilateralRefusal:'',
                definitionCustomerPart:'',
                requirementForParticipant:'',
                penalSystemPart:'',
                disabledPeopleOrgPart:'',

            },
            defaultItem: {
                customerDefinition: '',
                purchaseId:'',
                startContractPrice:'',
                otherTaxInPrice:'',
                startServicePrice:'',
                financeSource:'',
                provisionSize:'',
                accountDetailsId:'',
                contractConditionsCanBeChanged:'',
                FZ_44:'',
                contractInfo:'',
                unilateralRefusal:'',
                definitionCustomerPart:'',
                requirementForParticipant:'',
                penalSystemPart:'',
                disabledPeopleOrgPart:'',
            },
            token:'',
            role:'',
            notCount:null,
            FileTypes: [
                'application/vnd.oasis.opendocument.text',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/msword',
                'application/vnd.ms-word.document.macroEnabled.12',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/pdf',
            ],
            FileTypes2: [
                'application/vnd.oasis.opendocument.text',
                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                'application/msword',
                'application/vnd.ms-word.document.macroEnabled.12',
                'application/vnd.ms-excel',
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                'application/pdf',
                'application/x-7z-compressed',
                'application/octet-stream',
                'application/x-rar-compressed',
                'application/zip',
                'application/x-zip',
                'application/x-zip-compressed',
                'application/x-compress',
                'application/x-compressed',
                'multipart/x-zip',
                'image/bmp',
                'image/x-bmp',
                'image/x-bitmap',
                'image/x-xbitmap',
                'image/x-win-bitmap',
                'image/x-windows-bmp',
                'image/ms-bmp',
                'image/x-ms-bmp' ,
                'application/bmp',
                'application/x-bmp',
                'application/x-win-bitmap',
                'image/gif',
                'image/jpeg',
                'image/jp2',
                'image/png',
                'image/RAW',
                'image/x-dcraw',
            ],
            requestSelectsData: {
                filterRequestType: [
                    {
                        name: "ЭА",
                        id: "AUCTION_EL_FORM"
                    },
                    {
                        name: "ЭА ПСР",
                        id: "CONSTRUCTION_AUCTION_EL_FORM"
                    },
                    {
                        name: "ОК ЭФ",
                        id: "OPEN_CONTEST_EL_FORM"
                    },
                    {
                        name: "КсОУ",
                        id: "LIMITED_CONTEST"
                    },
                    {
                        name: "КсОУ ЭФ",
                        id: "LIMITED_CONTEST_EL_FORM"
                    },
                    {
                        name: "ДК ЭФ",
                        id: "TWO_STAGE_CONTEST_EL_FORM"
                    },
                    {
                        name: "ЗК ЭФ",
                        id: "QUOTATION_REQUEST_EL_FORM"
                    },
                    {
                        name: "ЗК ГП ЭФ",
                        id: "HUMANITARIAN_AID_QUOTATION_REQUEST_EL_FORM"
                    },
                    {
                        name: "ЗП ЭФ",
                        id: "OFFER_REQUEST_EL_FORM"
                    },
                    {
                        name: "ЕП ЭФ",
                        id: "SINGLE_SUPPLIER_PURCHASE_EL_FORM"
                    }
                ],
                performerUsers: [],
                customersList: [],
                filterRequestStatusForAdmin: [
                    {
                        name: 'НОВАЯ',
                        id: 'SEND_AFTER_CREATE'
                    },
                    {
                        name: 'В РАБОТЕ',
                        id: 'ASSIGNED'
                    },
                    {
                        name: 'ЗАМЕЧАНИЯ',
                        id: 'ON_REWORK'
                    },
                    {
                        name: 'УСТРАНЕНИЕ ЗАМЕЧАНИЙ',
                        id: 'SEND_AFTER_REWORK'
                    },
                    {
                        name: 'ОТОЗВАНА',
                        id: 'WITHDRAWN'
                    },
                    {
                        name: 'ОТКЛОНЕНА',
                        id: 'CANCELED'
                    },
                    {
                        name: 'ПРИНЯТА',
                        id: 'APPROVED'
                    },
                    {
                        name: 'ОПУБЛИКОВАНО',
                        id: 'PUBLISHED'
                    },
                    {
                        name: 'РАБОТА КОМИССИИ',
                        id: 'COMMISSION_WORK'
                    },
                    {
                        name: 'ОПРЕДЕЛЕНИЕ ПОСТАВЩИКА ЗАВЕРШЕНО',
                        id: 'SUPPLIER_DEFINITION_COMPLETED'
                    },
                    {
                        name: 'ОПРЕДЕЛЕНИЕ ПОСТАВЩИКА ОТМЕНЕНО',
                        id: 'SUPPLIER_DEFINITION_CANCELED'
                    }
                ],
                filterRequestStatusForCustomer: [
                    {
                        name: 'СОЗДАНА',
                        id: 'CREATED'
                    },
                    {
                        name: 'ОТПРАВЛЕНА',
                        id: 'SEND_AFTER_CREATE'
                    },
                    {
                        name: 'НА ПРОВЕРКЕ',
                        id: 'ASSIGNED'
                    },
                    {
                        name: 'ЗАМЕЧАНИЯ',
                        id: 'ON_REWORK'
                    },
                    {
                        name: 'УСТРАНЕНИЕ ЗАМЕЧАНИЙ',
                        id: 'SEND_AFTER_REWORK'
                    },
                    {
                        name: 'ОТОЗВАНА',
                        id: 'WITHDRAWN'
                    },
                    {
                        name: 'ОТКЛОНЕНА',
                        id: 'CANCELED'
                    },
                    {
                        name: 'ПРИНЯТА',
                        id: 'APPROVED'
                    },
                    {
                        name: 'ОПУБЛИКОВАНО',
                        id: 'PUBLISHED'
                    },
                    {
                        name: 'РАБОТА КОМИССИИ',
                        id: 'COMMISSION_WORK'
                    },
                    {
                        name: 'ОПРЕДЕЛЕНИЕ ПОСТАВЩИКА ЗАВЕРШЕНО',
                        id: 'SUPPLIER_DEFINITION_COMPLETED'
                    },
                    {
                        name: 'ОПРЕДЕЛЕНИЕ ПОСТАВЩИКА ОТМЕНЕНО',
                        id: 'SUPPLIER_DEFINITION_CANCELED'
                    }
                ],
                filterBoolean: [
                    {
                        name: 'Да',
                        id: true,
                    },
                    {
                        name: 'Нет',
                        id: false,
                    }
                ],
                date_of_admission_to_wg: false,
                date_of_publication: false,
                date_of_admission_bids_deadline: false,
                date_of_auction: false,
                date_of_review: false,
                eq_date_of_admission_to_wg_to: false,
                eq_date_of_publication_to: false,
                eq_date_of_admission_bids_deadline_to: false,
                eq_date_of_auction_to: false,
                eq_date_of_review_to: false,
            }
        }),


        created () {
            this.token = localStorage.getItem('token');
            this.role = localStorage.getItem('role');
            this.backUrl = localStorage.getItem('url');
            this.debouncedRequests = _.debounce(this.getRequests, 500)
            this.checkUnsavedRequests();
            this.getNotifications();
            this.getUsers();
            this.getCustomers();
        },

        mounted() {

            UpdateNote.$on('update-notes', data => {
                this.notInfo = data
                for (let i = 0; i < this.requests.length; i++){

                    for (let j = 0; j <  this.notInfo.length; j++){

                        if(this.requests[i].id == this.notInfo[j].requestId){
                            Vue.set(this.requests[i], 'notStatus', true)
                            Vue.set(this.requests[i], 'notificationId', this.notInfo[j].id)
                        }
                    }
                }
            });
        },

        watch: {
            sendDialog (val) {
                val || this.sendClose()
            },
            wordDialog (val) {
                val || this.wordClose()
            },
            revisionDialog (val) {
                val || this.revisionClose()
            },
            withdrawDialog (val) {
                val || this.withdrawClose()
            },
            acceptDialog (val) {
                val || this.acceptClose()
            },
            rejectDialog (val) {
                val || this.rejectClose()
            },
            performerDialog (val) {
                val || this.performerClose()
            },

            pagination: {
                handler () {
                    if(this.statusOnCreated){
                        this.getRequests();
                    }
                },
                deep: true
            },

            requestFilters: {
                handler () {
                    this.debouncedRequests()
                },
                deep: true
            },
        },

        computed: {
            yearsFinancing () {
                return Array.from({length: 50}, (value, index) => String(2017 + index))
            },

            formTitle () {
                return this.editedIndex === -1 ? 'Новый Контракт' : 'Редактировать Заявку'
            },

            pages () {
                if (this.pagination.rowsPerPage == null ||
                    this.pagination.totalItems == null
                ) return 0
                return Math.ceil(this.totalRequests / this.pagination.rowsPerPage)
            },

            filteredHeaders(){

                if(this.role == 'ROLE_ADMIN' || this.role == 'ROLE_EXPERT'){
                    return this.headers.filter(h => h.selected)
                }else{
                    return this.headers2.filter(h => h.selected)
                }

            },

            filteredItems(){
                if(this.role == 'ROLE_ADMIN' || this.role == 'ROLE_EXPERT'){
                    return this.requests.map(item => {
                        let filtered = Object.assign({}, item)
                        this.headers.forEach(header => {
                            if (!header.selected) delete filtered[header.value]
                        })
                        return filtered
                    })
                }else{
                    return this.requests.map(item => {
                        let filtered = Object.assign({}, item)
                        this.headers2.forEach(header => {
                            if (!header.selected) delete filtered[header.value]
                        })
                        return filtered
                    })
                }
            },

        },

        beforeDestroy () {
            UpdateNote.$off('update-notes');
        },

        destroyed() {
            this.toggleBodyClass('removeClass', 'over-table');
        },

        methods: {
            changeSort (column) {
                if (this.pagination.sortBy === column) {
                    this.pagination.descending = !this.pagination.descending
                } else {
                    this.pagination.sortBy = column
                    this.pagination.descending = false
                }
            },

            clearDate(val){
                this.requestFilters[val] = null
            },

            toggleBodyClass(addRemoveClass, className) {
                const el = document.body;

                if (addRemoveClass === 'addClass') {
                    el.classList.add(className);
                } else {
                    el.classList.remove(className);
                }
            },

            headerAllSelected(){
                let items = []
                if(this.role == 'ROLE_ADMIN' || this.role == 'ROLE_EXPERT'){
                    items = this.headers
                }else{
                    items = this.headers2
                }
                for(let i =0; i < items.length;i++){
                    Vue.set(items[i], 'selected', true)
                }
            },

            headerDefaultSelected(){

                    if(this.role == 'ROLE_ADMIN' || this.role == 'ROLE_EXPERT'){
                        let items = this.headers
                        for(let i =0; i < items.length;i++){
                            if(items[i].value == 'sort_id' || items[i].value == 'requestType' || items[i].value == 'sort_date_of_admission_to_wg' || items[i].value == 'sort_contract_name'
                                || items[i].value == 'status2' || items[i].value == 'sort_start_contract_price' || items[i].value == 'actions' || items[i].value == 'sort_customer_name' || items[i].value == 'sort_authority_user_name') {
                                Vue.set(items[i], 'selected', true)
                            }else{
                                Vue.set(items[i], 'selected', false)
                            }

                        }
                    }else{
                        let items = this.headers2
                        for(let i =0; i < items.length;i++){
                            if(items[i].value == 'sort_id' || items[i].value == 'requestType' || items[i].value == 'sort_date_of_admission_to_wg' || items[i].value == 'sort_contract_name'
                                || items[i].value == 'status2' || items[i].value == 'sort_start_contract_price' || items[i].value == 'actions') {
                                Vue.set(items[i], 'selected', true)
                            }else{
                                Vue.set(items[i], 'selected', false)
                            }
                        }
                    }

            },

            dateFormatted (val) {
                if (val) {
                    let date2 = new Date(val);
                    let year = date2.getFullYear();
                    let month = ("0" + (date2.getMonth() + 1)).slice(-2);
                    let day = ("0" + date2.getDate()).slice(-2);

                    return day + '.' + month + '.' + year;
                }
            },

            dateFormattedFilter (val) {
                if (val) {
                    let date2 = new Date(val);
                    let year = date2.getFullYear();
                    let month = ("0" + (date2.getMonth() + 1)).slice(-2);
                    let day = ("0" + date2.getDate()).slice(-2);

                    return day + '-' + month + '-' + year;
                }
            },

            showColumn(col) {

                if(this.role == 'ROLE_ADMIN' || this.role == 'ROLE_EXPERT'){
                    return this.headers.find(h => h.value === col).selected
                }else{
                    return this.headers2.find(h => h.value === col).selected
                }
            },

            checkUnsavedRequests(){
                setTimeout(() => {
                    let unsavedRequestKeys = this.unsavedRequestKeys
                    let notSavedRequests = this.notSavedRequests

                    this.$keysInStorage().then(function(keyName) {
                            for(let j = 0 ; j < keyName.length; j++){
                                if(keyName[j].length == 10){
                                    unsavedRequestKeys.push(keyName[j])
                                }
                            }
                            if(unsavedRequestKeys.length > 0){
                                Vue.set(notSavedRequests, 'status', true)
                            }

                    })
                }, 0)
            },

            refreshData(){
                this.getNotifications();
                this.getUsers();
            },

            supplierDefinitionShort(item){
                if (item == "AUCTION_EL_FORM"){
                    return "ЭА"
                }else if (item == "CONSTRUCTION_AUCTION_EL_FORM"){
                    return "ЭА ПСР"
                }else if (item == "OPEN_CONTEST_EL_FORM"){
                    return "ОК ЭФ"
                }else if (item == "LIMITED_CONTEST"){
                    return "КсОУ"
                }else if (item == "LIMITED_CONTEST_EL_FORM"){
                    return "КсОУ ЭФ"
                }else if (item == "TWO_STAGE_CONTEST_EL_FORM"){
                    return "ДК ЭФ"
                }else if (item == "QUOTATION_REQUEST_EL_FORM"){
                    return "ЗК ЭФ"
                }else if (item == "HUMANITARIAN_AID_QUOTATION_REQUEST_EL_FORM"){
                    return "ЗК ГП ЭФ"
                }else if (item == "OFFER_REQUEST_EL_FORM"){
                    return "ЗП ЭФ"
                }else if (item == "SINGLE_SUPPLIER_PURCHASE_EL_FORM"){
                    return "ЕП ЭФ"
                }else{
                    return ''
                }
            },

            getNotifications(){
                axios({
                    method: 'get',
                    url: this.backUrl + '/api/bids/notifications',
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token
                    },
                }).then(response => {
                    if(response.data) {
                        this.notInfo = response.data.data
                        this.getRequests()
                    }else{
                        this.getRequests()
                        this.notInfo = null
                    }
                })
            },

            getUsers(){
                axios({
                    method: 'get',
                    url: this.backUrl + '/api/users',
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token
                    },
                }).then(response => {
                    let role = ''
                    for(let i = 0; i < response.data.data.length; i++){
                        if(response.data.data[i].role == "ROLE_ADMIN" || response.data.data[i].role == "ROLE_EXPERT" ) {
                          if (response.data.data[i].role == "ROLE_ADMIN") {
                                role = "Администратор"
                            } else if(response.data.data[i].role == "ROLE_EXPERT"){
                                role = "Эксперт"
                            }
                            this.requestSelectsData.performerUsers.push({
                                name: response.data.data[i].fullname + ' (' + response.data.data[i].username + ') , ' + role,
                                id: response.data.data[i].id
                            })
                        }
                    }
                })
            },

            getCustomers(){
                axios({
                    method: 'get',
                    url: this.backUrl + '/api/customers',
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token
                    },
                }).then(response => {
                    this.requestSelectsData.customersList = response.data.data
                })
            },

            showStatus(status){
                if(this.role == "ROLE_ADMIN" || this.role == "ROLE_EXPERT"){
                    if (status == "CREATED"){
                        return "СОЗДАНА"
                    }else if (status == "SEND_AFTER_CREATE"){
                        return "НОВАЯ"
                    }else if (status == "ASSIGNED"){
                        return "В РАБОТЕ"
                    }else if (status == "ON_REWORK"){
                        return "ЗАМЕЧАНИЯ"
                    }else if (status == "SEND_AFTER_REWORK"){
                        return "УСТРАНЕНИЕ ЗАМЕЧАНИЙ"
                    }else if (status == "WITHDRAWN"){
                        return "ОТОЗВАНА"
                    }else if (status == "CANCELED"){
                        return "ОТКЛОНЕНА"
                    }else if (status == "APPROVED"){
                        return "ПРИНЯТА"
                    } else if (status == "PUBLISHED"){
                        return "ОПУБЛИКОВАНО"
                    }else if (status == "COMMISSION_WORK"){
                        return "РАБОТА КОМИССИИ"
                    }else if (status == "SUPPLIER_DEFINITION_COMPLETED"){
                        return "ОПРЕДЕЛЕНИЕ ПОСТАВЩИКА ЗАВЕРШЕНО"
                    }else if (status == "SUPPLIER_DEFINITION_CANCELED"){
                        return "ОПРЕДЕЛЕНИЕ ПОСТАВЩИКА ОТМЕНЕНО"
                    }else{
                        return ''
                    }
                }else{
                    if (status == "CREATED"){
                        return "СОЗДАНА"
                    }else if (status == "SEND_AFTER_CREATE"){
                        return "ОТПРАВЛЕНА"
                    }else if (status == "ASSIGNED"){
                        return "НА ПРОВЕРКЕ"
                    }else if (status == "ON_REWORK"){
                        return "ЗАМЕЧАНИЯ"
                    }else if (status == "SEND_AFTER_REWORK"){
                        return "УСТРАНЕНИЕ ЗАМЕЧАНИЙ"
                    }else if (status == "WITHDRAWN"){
                        return "ОТОЗВАНА"
                    }else if (status == "CANCELED"){
                        return "ОТКЛОНЕНА"
                    }else if (status == "APPROVED"){
                        return "ПРИНЯТА"
                    }else if (status == "PUBLISHED"){
                        return "ОПУБЛИКОВАНО"
                    }else if (status == "COMMISSION_WORK"){
                        return "РАБОТА КОМИССИИ"
                    }else if (status == "SUPPLIER_DEFINITION_COMPLETED"){
                        return "ОПРЕДЕЛЕНИЕ ПОСТАВЩИКА ЗАВЕРШЕНО"
                    }else if (status == "SUPPLIER_DEFINITION_CANCELED"){
                        return "ОПРЕДЕЛЕНИЕ ПОСТАВЩИКА ОТМЕНЕНО"
                    }else{
                        return ''
                    }
                }
            },

            getRequests() {
                this.deleteText = ''
                this.deleteTextAlert = false

                let startIndex = (this.pagination.page - 1) * this.pagination.rowsPerPage
                let params = {}
                this.tableLoading = true;

                params = {
                    start_index: startIndex,
                    count: this.pagination.rowsPerPage,
                }


                if(this.$route.params.requestType == 'allRequests'){
                    params.eq_customer_id = this.$route.params.id
                }else if(this.$route.params.requestType == 'allProcessedRequests'){
                    params.eq_customer_id = this.$route.params.id
                    params.eq_type = 'processed'
                }else if(this.$route.params.requestType == 'allNewRequests'){
                    params.eq_customer_id = this.$route.params.id
                    params.eq_type = 'new'
                }

                if(this.pagination.sortBy){
                    const direction = this.pagination.descending ? 'DESC' : 'ASC';
                    params[this.pagination.sortBy] = direction
                }

                for (let prop in this.requestFilters) {
                    if(this.requestFilters[prop] && this.requestFilters[prop].length > 0 && (prop == 'contains_years_of_financing' || prop == 'contains_customer_id' || prop == 'contains_authority_user_id' || prop == 'contains_status'  || prop == 'contains_supplier_definition_type')){
                        params[prop] = this.requestFilters[prop].join()
                    }else if(this.requestFilters[prop] || this.requestFilters[prop] === false){
                        if(prop == 'eq_date_of_admission_to_wg_from' || prop == 'eq_date_of_admission_to_wg_to' || prop == 'eq_date_of_publication_from' || prop == 'eq_date_of_publication_to'
                            || prop == 'eq_date_of_admission_bids_deadline_from' || prop == 'eq_date_of_admission_bids_deadline_to' || prop == 'eq_date_of_auction_from' || prop == 'eq_date_of_auction_to'
                            || prop == 'eq_date_of_review_from' || prop == 'eq_date_of_review_to'){
                            params[prop] = this.dateFormattedFilter(this.requestFilters[prop])
                        }else{
                            params[prop] = this.requestFilters[prop]
                        }
                    }
                }

                axios({
                    method: 'get',
                    url: this.backUrl + '/api/bids',
                    withCredentials: true,
                    headers: {
                        'Authorization': 'Basic ' + this.token
                    },
                    params: params
                })
                .then(response => {
                    if (response.data) {

                        let requestsArr = response.data.data;

                        if (this.role == 'ROLE_CUSTOMER_ADMIN' || this.role == 'ROLE_CUSTOMER_WORKER') {
                            this.$keysInStorage().then(function (keyName) {
                                for (let i = 0; i < requestsArr.length; i++) {
                                    for (let j = 0; j < keyName.length; j++) {
                                        if (requestsArr[i].id.toString() == keyName[j]) {
                                            Vue.set(requestsArr[i], 'changeStatus', true)
                                        }
                                    }
                                }
                            })
                        }

                        if (this.notInfo != null) {
                            for (let i = 0; i < requestsArr.length; i++) {

                                for (let j = 0; j < this.notInfo.length; j++) {

                                    if (requestsArr[i].id == this.notInfo[j].requestId) {
                                        Vue.set(requestsArr[i], 'notStatus', true)
                                        Vue.set(requestsArr[i], 'notificationId', this.notInfo[j].id)
                                    }
                                }
                            }
                        }

                        for (let i = 0; i < requestsArr.length; i++) {

                            Vue.set(requestsArr[i], 'status2', this.showStatus(requestsArr[i].status))
                            Vue.set(requestsArr[i], 'dateOfAdmissionToWG', this.convertDateTime(requestsArr[i].dateOfAdmissionToWG))
                            Vue.set(requestsArr[i], 'dateOfAuction', this.convertDateTime(requestsArr[i].dateOfAuction))
                            Vue.set(requestsArr[i], 'dateOfPublication', this.convertDateTime(requestsArr[i].dateOfPublication))
                            Vue.set(requestsArr[i], 'dateOfAdmissionBidsDeadline', this.convertDateTime(requestsArr[i].dateOfAdmissionBidsDeadline))
                            Vue.set(requestsArr[i], 'dateOfReview', this.convertDateTime(requestsArr[i].dateOfReview))


                            axios({
                                method: 'get',
                                url: this.backUrl + '/api/contracts/' + requestsArr[i].contractId,
                                withCredentials: true,
                                headers:{
                                    'Authorization': 'Basic ' + this.token
                                },
                            })
                            .then(response => {
                                Vue.set(requestsArr[i], 'requestName', response.data.name)
                                Vue.set(requestsArr[i], 'startContractPrice', this.priceFormat(response.data.startContractPrice))
                                Vue.set(requestsArr[i], 'definitionCustomerPart', response.data.definitionCustomerPart)
                                Vue.set(requestsArr[i], 'requirementForParticipant', response.data.requirementForParticipant)
                                Vue.set(requestsArr[i], 'disabledPeopleOrgPart', response.data.disabledPeopleOrgPart)
                                Vue.set(requestsArr[i], 'attractionAmount', response.data.attractionAmount)
                                Vue.set(requestsArr[i], 'penalSystemPart', response.data.penalSystemPart)
                                Vue.set(requestsArr[i], 'attractionPercent', response.data.attractionPercent)
                                Vue.set(requestsArr[i], 'yearsOfFinancing', response.data.yearsOfFinancing)
                                Vue.set(requestsArr[i], 'contractID', response.data.id)
                                Vue.set(requestsArr[i], 'contractUUID', response.data.uuid)
                                Vue.set(requestsArr[i], 'requestType', this.supplierDefinitionShort(response.data.supplierDefinitionType))
                            })
                            .finally(() => {
                                axios({
                                    method: 'get',
                                    url: this.backUrl + '/api/customers/' + requestsArr[i].customerId,
                                    withCredentials: true,
                                    headers: {
                                        'Authorization': 'Basic ' + this.token
                                    },
                                }).then(response => {
                                    Vue.set(requestsArr[i], 'customerName', response.data.name)
                                }).finally(() => {
                                    if(requestsArr[i].authorityUserId != null){
                                        axios({
                                            method: 'get',
                                            url: this.backUrl + '/api/users/' + requestsArr[i].authorityUserId,
                                            withCredentials: true,
                                            headers:{
                                                'Authorization': 'Basic ' + this.token
                                            },
                                        }).then(response => {
                                            Vue.set(requestsArr[i], 'authorityUser', response.data.fullname)
                                        })
                                    }
                                    if ((i + 1) == requestsArr.length) {
                                        setTimeout(() => {
                                            Vue.nextTick(() => this.requests = requestsArr);
                                            this.toggleBodyClass('addClass', 'over-table');
                                            this.tableLoading = false
                                        }, 300)
                                    }
                                });
                            });

                        }
                        this.totalRequests = Number(response.data.metadata.total_count);
                    }else{
                        this.requests = []
                        this.totalRequests = 0
                        this.tableLoading = false
                    }
                    this.statusOnCreated = true
                })
                .catch(() => this.tableLoading = false)
            },

            sendBid(item){
                this.sendBidItems = Object.assign({}, item)
                this.sendFilesArr = []
                this.sendBidItems.comment = ''
                this.sendDialog = true
            },

            revisionBid(item){
                this.revisionBidItems = Object.assign({}, item)
                this.revisionFilesArr = []
                this.revisionBidItems.revisionComment = ''
                this.revisionDialog = true
            },

            withdrawBid(item){
                this.withdrawBidItems = Object.assign({}, item)
                this.withdrawDialog = true
            },

            acceptBid(item){
                this.acceptBidItems = Object.assign({}, item)
                this.acceptDialog = true
            },

            rejectBid(item){
                this.rejectBidItems = Object.assign({}, item)
                this.rejectDialog = true
            },

            performerBid(item){
                this.performerBidItems = Object.assign({}, item)
                this.performerBidItems.authorityUserId = ''
                this.performerDialog = true
            },

            deleteItem (item) {
                this.editedItem = Object.assign({}, item)
                const index = this.requests.indexOf(item)

                if(confirm('Вы уверены, что хотите удалить этого заказчика ?')) {
                    axios({
                        method: 'delete',
                        url: this.backUrl + '/api/bids',
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                        data: {
                            id: this.editedItem.id,
                            uuid: this.editedItem.uuid,
                        },
                    }).then(() => {

                        Object.assign(this.requests[index])
                        this.deleteTextAlert = true
                        setTimeout(() => {
                            this.deleteTextAlert = false
                        }, 3000)
                    }).catch(error => {
                        if(error.response.data.code == 401){
                            this.$router.push('/login');
                        }
                    });
                }


            },

            sendClose () {
                this.sendDialog = false
                setTimeout(() => {
                    this.sendBidItems = Object.assign({}, [])
                    this.sendErrorAlert = false
                    this.sendSuccessAlert = false
                    this.sendSuccessText = ''
                    this.sendErrorText = ''
                }, 300)

            },

            revisionClose () {
                this.revisionDialog = false
                setTimeout(() => {
                    this.revisionBidItems = Object.assign({}, [])
                    this.revisionErrorAlert = false
                    this.revisionSuccessAlert = false
                    this.revisionSuccessText = ''
                    this.revisionErrorText = ''
                }, 300)
            },

            withdrawClose () {
                this.withdrawDialog = false
                setTimeout(() => {
                    this.withdrawBidItems = Object.assign({}, [])
                    this.withdrawErrorAlert = false
                    this.withdrawSuccessAlert = false
                    this.withdrawSuccessText = ''
                    this.withdrawErrorText = ''
                }, 300)
            },

            rejectClose () {
                this.rejectDialog = false
                setTimeout(() => {
                    this.rejectBidItems = Object.assign({}, [])
                    this.rejectErrorAlert = false
                    this.rejectSuccessAlert = false
                    this.rejectSuccessText = ''
                    this.rejectErrorText = ''
                }, 300)
            },

            acceptClose () {
                this.acceptDialog = false
                setTimeout(() => {
                    this.acceptBidItems = Object.assign({}, [])
                    this.acceptErrorAlert = false
                    this.acceptSuccessAlert = false
                    this.acceptSuccessText = ''
                    this.acceptErrorText = ''
                }, 300)
            },

            performerClose () {
                this.performerDialog = false
                setTimeout(() => {
                    this.performerBidItems = Object.assign({}, [])
                    this.performerErrorAlert = false
                    this.performerSuccessAlert = false
                    this.performerSuccessText = ''
                    this.performerErrorText = ''
                }, 300)
            },

            sendSave (comment) {

                    if(this.$refs.sendFilespond.getFiles().length > 0) {
                        axios({
                            method: 'post',
                            url: this.backUrl + '/api/documents',
                            withCredentials: true,
                            headers: {
                                'Authorization': 'Basic ' + this.token
                            },
                            data: {},
                        }).then(response => {
                            let sendFiles = JSON.parse(response.data.objectJson).id;

                            axios({
                                method: 'put',
                                url: this.backUrl + '/api/bids/send',
                                withCredentials: true,
                                headers: {
                                    'Authorization': 'Basic ' + this.token
                                },
                                data: {
                                    id: this.sendBidItems.id,
                                    uuid: this.sendBidItems.uuid,
                                    comment: comment,
                                    commentFileId: sendFiles,
                                },
                            }).then(() => {
                                this.getRequests()
                                this.inputErrors = ''
                                this.sendSuccessText = "Заявка успешно отправлено"
                                this.sendSuccessAlert = true
                                setTimeout(() => {
                                    this.sendClose()
                                }, 1500)
                                for (let i = 0; i < this.$refs.sendFilespond.getFiles().length; i++) {
                                    if (this.$refs.sendFilespond.getFiles()[i].status != 8) {

                                        let formData = new FormData();
                                        formData.append('filename', this.$refs.sendFilespond.getFiles()[i].file.name);
                                        formData.append('data', this.$refs.sendFilespond.getFiles()[i].file);
                                        formData.append('documentId', sendFiles);

                                        axios.post(this.backUrl + '/api/documents/files',
                                            formData,
                                            {
                                                withCredentials: true,
                                                headers: {
                                                    'Content-Type': 'multipart/form-data',
                                                    'Authorization': 'Basic ' + localStorage.getItem('token')
                                                }
                                            }
                                        )
                                    }
                                }
                            })
                            .catch(error => {
                                let errors = error.response.data.description;
                                this.sendErrorText = errors
                                this.sendErrorAlert = true

                            });

                            })
                    }else{
                        axios({
                            method: 'put',
                            url: this.backUrl + '/api/bids/send',
                            withCredentials: true,
                            headers: {
                                'Authorization': 'Basic ' + this.token
                            },
                            data: {
                                id: this.sendBidItems.id,
                                uuid: this.sendBidItems.uuid,
                                comment: comment,
                            },
                        }).then(() => {
                            this.getRequests()
                            this.inputErrors = ''
                            this.sendSuccessText = "Заявка успешно отправлено"
                            this.sendSuccessAlert = true
                            setTimeout(() => {
                                this.sendClose()
                            }, 1500)
                        })
                        .catch(error => {
                            let errors = error.response.data.description;
                            this.sendErrorText = errors
                            this.sendErrorAlert = true

                        });
                    }

            },

            withdrawSave (comment) {

                if(this.$refs.withdrawFilespond.getFiles().length > 0) {
                    axios({
                        method: 'post',
                        url: this.backUrl + '/api/documents',
                        withCredentials: true,
                        headers: {
                            'Authorization': 'Basic ' + this.token
                        },
                        data: {},
                    }).then(response => {
                        let withdrawFiles = JSON.parse(response.data.objectJson).id;

                        axios({
                            method: 'put',
                            url: this.backUrl + '/api/bids/withdraw',
                            withCredentials: true,
                            headers: {
                                'Authorization': 'Basic ' + this.token
                            },
                            data: {
                                id: this.withdrawBidItems.id,
                                uuid: this.withdrawBidItems.uuid,
                                comment: comment,
                                commentFileId: withdrawFiles,
                            },
                        }).then(() => {
                            this.getRequests()
                            this.withdrawSuccessText = "Заявка успешно отозвано"
                            this.withdrawSuccessAlert = true
                            setTimeout(() => {
                                this.withdrawClose()
                            }, 1500)
                            for (let i = 0; i < this.$refs.withdrawFilespond.getFiles().length; i++) {
                                if (this.$refs.withdrawFilespond.getFiles()[i].status != 8) {

                                    let formData = new FormData();
                                    formData.append('filename', this.$refs.withdrawFilespond.getFiles()[i].file.name);
                                    formData.append('data', this.$refs.withdrawFilespond.getFiles()[i].file);
                                    formData.append('documentId', withdrawFiles);

                                    axios.post(this.backUrl + '/api/documents/files',
                                        formData,
                                        {
                                            withCredentials: true,
                                            headers: {
                                                'Content-Type': 'multipart/form-data',
                                                'Authorization': 'Basic ' + localStorage.getItem('token')
                                            }
                                        }
                                    )
                                }
                            }
                        })
                        .catch(error => {
                            if(this.withdrawBidItems.status == "WITHDRAWN"){
                                this.withdrawErrorText = 'Статус заявки "Отозвана" , вы больше не можете отозвать заявку.'
                            }else if(this.withdrawBidItems.status == "APPROVED"){
                                this.withdrawErrorText = 'Статус заявки "Принята" , вы больше не можете отозвать заявку.'
                            }else if(this.withdrawBidItems.status == "CANCELED"){
                                this.withdrawErrorText = 'Статус заявки "Отклонена" , вы больше не можете отозвать заявку.'
                            }else{
                                let errors = error.response.data.description;
                                this.withdrawErrorText = errors
                            }
                            this.withdrawErrorAlert = true

                        });

                    })
                }else{
                    axios({
                        method: 'put',
                        url: this.backUrl + '/api/bids/withdraw',
                        withCredentials: true,
                        headers: {
                            'Authorization': 'Basic ' + this.token
                        },
                        data: {
                            id: this.withdrawBidItems.id,
                            uuid: this.withdrawBidItems.uuid,
                            comment: comment
                        },
                    }).then(() => {
                        this.getRequests()
                        this.withdrawSuccessText = "Заявка успешно отозвано"
                        this.withdrawSuccessAlert = true
                        setTimeout(() => {
                            this.withdrawClose()
                        }, 1500)
                    })
                    .catch(error => {
                        if(this.withdrawBidItems.status == "WITHDRAWN"){
                            this.withdrawErrorText = 'Статус заявки "Отозвана" , вы больше не можете отозвать заявку.'
                        }else if(this.withdrawBidItems.status == "APPROVED"){
                            this.withdrawErrorText = 'Статус заявки "Принята" , вы больше не можете отозвать заявку.'
                        }else if(this.withdrawBidItems.status == "CANCELED"){
                            this.withdrawErrorText = 'Статус заявки "Отклонена" , вы больше не можете отозвать заявку.'
                        }else{
                            let errors = error.response.data.description;
                            this.withdrawErrorText = errors
                        }
                        this.withdrawErrorAlert = true

                    });
                }

            },

            revisionSave (comment) {
                if(this.$refs.revisionFilespond.getFiles().length > 0) {
                    axios({
                        method: 'post',
                        url: this.backUrl + '/api/documents',
                        withCredentials: true,
                        headers: {
                            'Authorization': 'Basic ' + this.token
                        },
                        data: {},
                    }).then(response => {
                        let revisionFiles = JSON.parse(response.data.objectJson).id;


                        axios({
                            method: 'put',
                            url: this.backUrl + '/api/bids/onRework',
                            withCredentials: true,
                            headers: {
                                'Authorization': 'Basic ' + this.token
                            },
                            data: {
                                id: this.revisionBidItems.id,
                                uuid: this.revisionBidItems.uuid,
                                comment: comment,
                                commentFileId: revisionFiles,
                            },
                        }).then(() => {
                            this.getRequests()
                            this.revisionSuccessText = "Заявка успешно отправлено"
                            this.revisionSuccessAlert = true
                            setTimeout(() => {
                                this.revisionClose()
                            }, 1500)
                            for (let i = 0; i < this.$refs.revisionFilespond.getFiles().length; i++) {
                                if (this.$refs.revisionFilespond.getFiles()[i].status != 8) {

                                    let formData = new FormData();
                                    formData.append('filename', this.$refs.revisionFilespond.getFiles()[i].file.name);
                                    formData.append('data', this.$refs.revisionFilespond.getFiles()[i].file);
                                    formData.append('documentId', revisionFiles);

                                    axios.post(this.backUrl + '/api/documents/files',
                                        formData,
                                        {
                                            withCredentials: true,
                                            headers: {
                                                'Content-Type': 'multipart/form-data',
                                                'Authorization': 'Basic ' + localStorage.getItem('token')
                                            }
                                        }
                                    )
                                }
                            }
                        })
                        .catch(error => {
                            let errors = error.response.data.description;
                            this.revisionErrorText = errors
                            this.revisionErrorAlert = true

                        });
                    })

                }else{
                    axios({
                        method: 'put',
                        url: this.backUrl + '/api/bids/onRework',
                        withCredentials: true,
                        headers: {
                            'Authorization': 'Basic ' + this.token
                        },
                        data: {
                            id: this.revisionBidItems.id,
                            uuid: this.revisionBidItems.uuid,
                            comment: comment,
                        },
                    }).then(() => {
                        this.getRequests()
                        this.revisionSuccessText = "Заявка успешно отправлено"
                        this.revisionSuccessAlert = true
                        setTimeout(() => {
                            this.revisionClose()
                        }, 1500)
                    })
                    .catch(error => {
                        let errors = error.response.data.description;
                        this.revisionErrorText = errors
                        this.revisionErrorAlert = true

                    });
                }
            },

            rejectSave (comment) {

                if(this.$refs.rejectFilespond.getFiles().length > 0) {

                    axios({
                        method: 'post',
                        url: this.backUrl + '/api/documents',
                        withCredentials: true,
                        headers: {
                            'Authorization': 'Basic ' + this.token
                        },
                        data: {},
                    }).then(response => {
                        let rejectFiles = JSON.parse(response.data.objectJson).id;
                        axios({
                            method: 'put',
                            url: this.backUrl + '/api/bids/cancel',
                            withCredentials: true,
                            headers:{
                                'Authorization': 'Basic ' + this.token
                            },
                            data: {
                                id: this.rejectBidItems.id,
                                uuid: this.rejectBidItems.uuid,
                                comment: comment,
                                commentFileId: rejectFiles,
                            },
                        }).then(() => {
                            this.getRequests()
                            this.rejectSuccessText = "Заявка успешно отклонено"
                            this.rejectSuccessAlert = true
                            setTimeout(() => {
                                this.rejectClose()
                            }, 1500)
                            for (let i = 0; i < this.$refs.rejectFilespond.getFiles().length; i++) {
                                if (this.$refs.rejectFilespond.getFiles()[i].status != 8) {

                                    let formData = new FormData();
                                    formData.append('filename', this.$refs.rejectFilespond.getFiles()[i].file.name);
                                    formData.append('data', this.$refs.rejectFilespond.getFiles()[i].file);
                                    formData.append('documentId', rejectFiles);

                                    axios.post(this.backUrl + '/api/documents/files',
                                        formData,
                                        {
                                            withCredentials: true,
                                            headers: {
                                                'Content-Type': 'multipart/form-data',
                                                'Authorization': 'Basic ' + localStorage.getItem('token')
                                            }
                                        }
                                    )
                                }
                            }
                        })
                        .catch(error => {
                            let errors = error.response.data.description;
                            this.rejectErrorText = errors
                            this.rejectErrorAlert = true
                        });
                    })
                }else{
                    axios({
                        method: 'put',
                        url: this.backUrl + '/api/bids/cancel',
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                        data: {
                            id: this.rejectBidItems.id,
                            uuid: this.rejectBidItems.uuid,
                            comment: comment
                        },
                    }).then(() => {
                        this.getRequests()
                        this.rejectSuccessText = "Заявка успешно отклонено"
                        this.rejectSuccessAlert = true
                        setTimeout(() => {
                            this.rejectClose()
                        }, 1500)
                    })
                    .catch(error => {
                        let errors = error.response.data.description;
                        this.rejectErrorText = errors
                        this.rejectErrorAlert = true

                    });
                }
            },

            acceptSave (comment) {
                if(this.$refs.acceptFilespond.getFiles().length > 0) {

                    axios({
                        method: 'post',
                        url: this.backUrl + '/api/documents',
                        withCredentials: true,
                        headers: {
                            'Authorization': 'Basic ' + this.token
                        },
                        data: {},
                    }).then(response => {
                        let acceptFiles = JSON.parse(response.data.objectJson).id;

                        axios({
                            method: 'put',
                            url: this.backUrl + '/api/bids/approve',
                            withCredentials: true,
                            headers:{
                                'Authorization': 'Basic ' + this.token
                            },
                            data: {
                                id: this.acceptBidItems.id,
                                uuid: this.acceptBidItems.uuid,
                                comment: comment,
                                commentFileId: acceptFiles,
                            },
                        }).then(() => {
                            this.getRequests()
                            this.acceptSuccessText = "Заявка успешно принято"
                            this.acceptSuccessAlert = true
                            setTimeout(() => {
                                this.acceptClose()
                            }, 1500)
                            for (let i = 0; i < this.$refs.acceptFilespond.getFiles().length; i++) {
                                if (this.$refs.acceptFilespond.getFiles()[i].status != 8) {

                                    let formData = new FormData();
                                    formData.append('filename', this.$refs.acceptFilespond.getFiles()[i].file.name);
                                    formData.append('data', this.$refs.acceptFilespond.getFiles()[i].file);
                                    formData.append('documentId', acceptFiles);

                                    axios.post(this.backUrl + '/api/documents/files',
                                        formData,
                                        {
                                            withCredentials: true,
                                            headers: {
                                                'Content-Type': 'multipart/form-data',
                                                'Authorization': 'Basic ' + localStorage.getItem('token')
                                            }
                                        }
                                    )
                                }
                            }
                        })
                        .catch(error => {
                            let errors = error.response.data.description;
                            this.acceptErrorText = errors
                            this.acceptErrorAlert = true

                        });
                    })
                }else{
                    axios({
                        method: 'put',
                        url: this.backUrl + '/api/bids/approve',
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                        data: {
                            id: this.acceptBidItems.id,
                            uuid: this.acceptBidItems.uuid,
                            comment: comment
                        },
                    }).then(() => {
                        this.getRequests()
                        this.acceptSuccessText = "Заявка успешно принято"
                        this.acceptSuccessAlert = true
                        setTimeout(() => {
                            this.acceptClose()
                        }, 1500)
                    })
                    .catch(error => {
                        let errors = error.response.data.description;
                        this.acceptErrorText = errors
                        this.acceptErrorAlert = true

                    });
                }
            },

            performerSave () {
                axios({
                    method: 'put',
                    url: this.backUrl + '/api/bids/assignToExpert',
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token
                    },
                    data: {
                        id: this.performerBidItems.id,
                        uuid: this.performerBidItems.uuid,
                        authorityUserId: this.performerBidItems.authorityUserId,
                    },
                }).then(() => {
                    this.getRequests()
                    this.performerSuccessText = "Исполнитель успешно назначен"
                    this.performerSuccessAlert = true
                    setTimeout(() => {
                        this.performerClose()
                    }, 1500)
                })
                .catch(error => {
                    let errors = error.response.data.description;
                    this.performerErrorText = errors
                    this.performerErrorAlert = true

                });
            },

            request_info(item){
                this.$router.push({ name: 'request', params: { item: item , id: item.id } })
            },

            addRequest(){
                let changeKey = Math.random().toString(36).substr(2, 10)
                this.$setItem(changeKey)
                this.$router.push({ name: 'add_request', params: { id: changeKey } })
            },

            unsavedRequests(item){
                this.$router.push({ name: 'unsavedRequests', params: { item: item }})
            },

            fnExcelReport () {
                this.excelLoading = true

                let params = {}

                if(this.pagination.sortBy){
                    const direction = this.pagination.descending ? 'DESC' : 'ASC';
                    params[this.pagination.sortBy] = direction
                }

                if(this.$route.params.requestType == 'allRequests'){
                    params.eq_customer_id = this.$route.params.id
                }else if(this.$route.params.requestType == 'allProcessedRequests'){
                    params.eq_customer_id = this.$route.params.id
                    params.eq_type = 'processed'
                }else if(this.$route.params.requestType == 'allNewRequests'){
                    params.eq_customer_id = this.$route.params.id
                    params.eq_type = 'new'
                }

                for (let prop in this.requestFilters) {
                    if(this.requestFilters[prop] || this.requestFilters[prop] === false){
                        if(this.requestFilters[prop] && this.requestFilters[prop].length > 0 && (prop == 'contains_years_of_financing' || prop == 'contains_customer_id' || prop == 'contains_authority_user_id' || prop == 'contains_status'  || prop == 'contains_supplier_definition_type')){
                            params[prop] = this.requestFilters[prop].join()
                        }else if(prop == 'eq_date_of_admission_to_wg_from' || prop == 'eq_date_of_admission_to_wg_to' || prop == 'eq_date_of_publication_from' || prop == 'eq_date_of_publication_to'
                            || prop == 'eq_date_of_admission_bids_deadline_from' || prop == 'eq_date_of_admission_bids_deadline_to' || prop == 'eq_date_of_auction_from' || prop == 'eq_date_of_auction_to'
                            || prop == 'eq_date_of_review_from' || prop == 'eq_date_of_review_to'){
                            params[prop] = this.dateFormattedFilter(this.requestFilters[prop])
                        }else{
                            params[prop] = this.requestFilters[prop]
                        }
                    }
                }
                axios({
                    method: 'get',
                    url: this.backUrl + '/api/bids',
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token
                    },
                    params: params
                })
                    .then(response => {
                        if(response.data){
                            let requestsArr = response.data.data;


                            for(let i = 0; i < requestsArr.length; i++){
                                Vue.set(requestsArr[i], 'status2', this.showStatus(requestsArr[i].status))
                                Vue.set(requestsArr[i], 'dateOfAdmissionToWG', this.convertDateTime(requestsArr[i].dateOfAdmissionToWG))
                                Vue.set(requestsArr[i], 'dateOfAuction', this.convertDateTime(requestsArr[i].dateOfAuction))
                                Vue.set(requestsArr[i], 'dateOfPublication', this.convertDateTime(requestsArr[i].dateOfPublication))
                                Vue.set(requestsArr[i], 'dateOfAdmissionBidsDeadline', this.convertDateTime(requestsArr[i].dateOfAdmissionBidsDeadline))
                                Vue.set(requestsArr[i], 'dateOfReview', this.convertDateTime(requestsArr[i].dateOfReview))
                                Vue.set(requestsArr[i], 'didNotTakePlace', this.checkboxVal(requestsArr[i].didNotTakePlace))
                                Vue.set(requestsArr[i], 'protocol1', requestsArr[i].initialNumberOfAllowed ? requestsArr[i].initialNumberOfAllowed : '')
                                Vue.set(requestsArr[i], 'protocol2', requestsArr[i].finalNumberOfAllowed ? requestsArr[i].finalNumberOfAllowed : '')
                                Vue.set(requestsArr[i], 'savedMoney', this.priceFormatForExcel(requestsArr[i].savedMoney))
                                Vue.set(requestsArr[i], 'bidPrice', this.priceFormatForExcel(requestsArr[i].bidPrice))


                                axios({
                                    method: 'get',
                                    url: this.backUrl + '/api/contracts/' + requestsArr[i].contractId,
                                    withCredentials: true,
                                    headers:{
                                        'Authorization': 'Basic ' + this.token
                                    },
                                })
                                    .then(response => {
                                        Vue.set(requestsArr[i], 'requestName', response.data.name)
                                        Vue.set(requestsArr[i], 'startContractPrice', this.priceFormatForExcel(response.data.startContractPrice))
                                        Vue.set(requestsArr[i], 'cmp', response.data.definitionCustomerPart  ? "Да" : '')
                                        Vue.set(requestsArr[i], 'disabledPeopleOrgPart', this.checkboxVal(response.data.disabledPeopleOrgPart))
                                        Vue.set(requestsArr[i], 'attractionAmount', response.data.attractionAmount ? (this.priceFormatForExcel(response.data.attractionAmount) + ' (' + response.data.attractionPercent + '% от НМЦ)') : '')
                                        Vue.set(requestsArr[i], 'penalSystemPart', this.checkboxVal(response.data.penalSystemPart))
                                        Vue.set(requestsArr[i], 'yearsOfFinancing', response.data.yearsOfFinancing ? response.data.yearsOfFinancing.join() : '')
                                        Vue.set(requestsArr[i], 'requestType', this.supplierDefinitionShort(response.data.supplierDefinitionType))
                                    })
                                    .finally(() => {
                                        axios({
                                            method: 'get',
                                            url: this.backUrl + '/api/customers/' + requestsArr[i].customerId,
                                            withCredentials: true,
                                            headers: {
                                                'Authorization': 'Basic ' + this.token
                                            },
                                        }).then(response => {
                                            Vue.set(requestsArr[i], 'customerName', response.data.name)
                                        }).finally(() => {
                                            if(requestsArr[i].authorityUserId != null){
                                                axios({
                                                    method: 'get',
                                                    url: this.backUrl + '/api/users/' + requestsArr[i].authorityUserId,
                                                    withCredentials: true,
                                                    headers:{
                                                        'Authorization': 'Basic ' + this.token
                                                    },
                                                }).then(response => {
                                                    Vue.set(requestsArr[i], 'authorityUser', response.data.fullname)
                                                })
                                            }
                                            if ((i + 1) == requestsArr.length) {
                                                setTimeout(() => {
                                                    this.excelSave(requestsArr)
                                                }, 300)
                                            }
                                        });
                                    });

                            }

                        }else{
                            this.excelSave([])
                        }
                    })

            },

            excelSave(data){

                let excelHeaders = []
                for(let i = 0; i < this.headers.length; i ++){
                    if(!this.headers[i].selected){
                        excelHeaders.push (this.headers[i].excelVal)
                    }
                }

                let excelItems = []

                excelItems = Object.assign([], data)

                let wb = new Excel.Workbook();
                let ws = wb.addWorksheet('Таблица заявок');

                ws.columns = [
                    { header: 'Номер заявки', key: 'id', width: 15, style: {alignment  : {wrapText: true, horizontal: 'left'} }},
                    { header: 'Тип', key: 'requestType', width: 10, style: {alignment  : {wrapText: true, horizontal: 'left'} } },
                    { header: 'Поступление на РГ', key: 'dateOfAdmissionToWG', width: 20, style: {alignment  : {wrapText: true, horizontal: 'left'} } },
                    { header: 'Заказчик', key: 'customerName', width: 40, style: {alignment  : {wrapText: true, horizontal: 'left'} } },
                    { header: 'Исполнитель', key: 'authorityUser', width: 40, style: {alignment  : {wrapText: true, horizontal: 'left'} } },
                    { header: 'Предмет лота', key: 'requestName', width: 50 , style: {alignment  : {wrapText: true, horizontal: 'left'} }},
                    { header: 'Статус', key: 'status2', width: 20, style: {alignment  : {wrapText: true, horizontal: 'left'} } },
                    { header: 'Дата публикации', key: 'dateOfPublication', width: 20, style: {alignment  : {wrapText: true, horizontal: 'left'} } },
                    { header: 'Дата окончания подачи заявок', key: 'dateOfAdmissionBidsDeadline', width: 30 , style: {alignment  : {wrapText: true, horizontal: 'left'} }},
                    { header: 'Дата аукциона', key: 'dateOfAuction', width: 20 , style: {alignment  : {wrapText: true, horizontal: 'left'} }},
                    { header: 'Год финансирования', key: 'yearsOfFinancing', width: 25 , style: {alignment  : {wrapText: true, horizontal: 'left'} }},
                    { header: 'Реестровый номер извещения', key: 'noticeRegNumber', width: 35 , style: {alignment  : {wrapText: true, horizontal: 'left'} }},
                    { header: 'НМЦ', key: 'startContractPrice', width: 15 , style: {alignment  : {wrapText: true, horizontal: 'left'} }},
                    { header: 'Цена по итогам торгов', key: 'bidPrice', width: 25 , style: {alignment  : {wrapText: true, horizontal: 'left'} }},
                    { header: 'Дата подведения итогов', key: 'dateOfReview', width: 25, style: {alignment  : {wrapText: true, horizontal: 'left'} } },
                    { header: 'Экономия', key: 'savedMoney', width: 20 , style: {alignment  : {wrapText: true, horizontal: 'left'} } ,font: {size: 8}},
                    { header: 'Кол-во участников', key: 'numberOfParticipants', width: 20, style: {alignment  : {wrapText: true, horizontal: 'left'} } },
                    { header: 'Кол-во допущенных (1 протокол)', key: 'protocol1', width: 35 , style: {alignment  : {wrapText: true, horizontal: 'left'} }},
                    { header: 'Кол-во допущенных (итоговый протокол)', key: 'protocol2', width: 45 , style: {alignment  : {wrapText: true, horizontal: 'left'} }},
                    { header: 'Не состоялся', key: 'didNotTakePlace', width: 15 , style: {alignment  : {wrapText: true, horizontal: 'left'} } },
                    { header: 'СМП', key: 'cmp', width: 20 , style: {alignment  : {wrapText: true, horizontal: 'left'} } ,font: {size: 8}},
                    { header: 'Сумма привлечения СМП', key: 'attractionAmount', width: 30, style: {alignment  : {wrapText: true, horizontal: 'left'} } },
                    { header: 'Инвалиды', key: 'disabledPeopleOrgPart', width: 15, style: {alignment  : {wrapText: true, horizontal: 'left'} } },
                    { header: 'УИС', key: 'penalSystemPart', width: 10 , style: {alignment  : {wrapText: true, horizontal: 'left'} }},
                    { header: 'Победитель', key: 'winner', width: 25 , style: {alignment  : {wrapText: true, horizontal: 'left'} }},
                ];

                for(let i = 0; i < ws.columns.length; i++){
                    for(let j = 0; j < excelHeaders.length; j++){
                        if(ws.columns[i]._key == excelHeaders[j]){
                            ws.getColumn(i + 1).hidden = true;
                        }
                    }
                }

                ws.getRow(1).font = { bold: true };
                ws.getRow(1).alignment = { vertical: 'middle', horizontal: 'center' };
                ws.getRow(2).font = { underline: 'double' };
                ws.addRows(excelItems);


                wb.xlsx.writeBuffer().then( data => {
                    const blob = new Blob( [data], {type: "application/octet-stream"} );
                    saveAs( blob, 'Таблица заявок.xlsx');
                });

                this.excelLoading = false
            },

            b64toBlob(b64Data, contentType, sliceSize) {
                contentType = contentType || '';
                sliceSize = sliceSize || 512;

                let byteCharacters = atob(b64Data);
                let byteArrays = [];

                for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                    let slice = byteCharacters.slice(offset, offset + sliceSize);

                    let byteNumbers = new Array(slice.length);
                    for (let i = 0; i < slice.length; i++) {
                        byteNumbers[i] = slice.charCodeAt(i);
                    }

                    let byteArray = new Uint8Array(byteNumbers);

                    byteArrays.push(byteArray);
                }

                let blob = new Blob(byteArrays, {type: contentType});
                return blob;
            },

            uploadArchive(id){
                this.loading = id
                axios({
                    method: 'get',
                    url: this.backUrl + '/api/bids/documents/' + id,
                    withCredentials: true,
                    headers: {
                        'Authorization': 'Basic ' + this.token
                    },

                }).then(response => {
                    let contentType = response.data.headers['Content-Type'][0];
                    let blob = this.b64toBlob(response.data.body, contentType);
                    let blobUrl = URL.createObjectURL(blob);

                    let tempLink = document.createElement('a');
                    tempLink.href = blobUrl;
                    tempLink.setAttribute('download', 'Заявка №'+ id+ '(документы).zip');
                    tempLink.click();
                    this.loading = false

                })
            },

            saveUpdate (items,key, val) {
                axios({
                    method: 'put',
                    url: this.backUrl + '/api/bids',
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token
                    },
                    data: {
                        id: items.id,
                        uuid: items.uuid,
                        [key] : val,
                    },
                }).then(() => {
                    this.getRequests()
                    this.snack = true
                    this.snackColor = 'success'
                    this.snackText = 'Данные успешно сохранены'
                    this.dialog =false

                }).catch(() => {
                    this.snack = true
                    this.snackColor = 'error'
                    this.snackText = 'Данные не сохранены'
                });
            },

            saveUpdateStatus(items, val) {

                let url = ''

                if(val == 'PUBLISHED'){
                    url = '/api/bids/publish'
                }else if(val == 'COMMISSION_WORK'){
                    url = '/api/bids/toCommissionWork'
                }else if(val == 'SUPPLIER_DEFINITION_COMPLETED'){
                    url = '/api/bids/toSupplierDefinitionCompleted'
                }else if(val == 'SUPPLIER_DEFINITION_CANCELED'){
                    url = '/api/bids/toSupplierDefinitionCanceled'
                }

                axios({
                    method: 'put',
                    url: this.backUrl + url,
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token
                    },
                    data: {
                        id: items.id,
                        uuid: items.uuid,
                    },
                }).then(() => {
                    this.getRequests()
                    this.snack = true
                    this.snackColor = 'success'
                    this.snackText = 'Данные успешно сохранены'
                    this.dialog =false

                }).catch(() => {
                    this.snack = true
                    this.snackColor = 'error'
                    this.snackText = 'Данные не сохранены'
                });
            },

            priceFormat(newValue){
              if(newValue) {
                  let val = newValue.toString().replace(/\s/g, '')
                  return  (+val).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1 ")
              }
            },

            priceFormatForExcel(newValue){
                if(newValue) {
                    let val = newValue.toString().replace(/\s/g, '')
                    return  (+val).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1 ").replace(/\./g,",")
                }
            },

            formatPrice(value) {
                if(value){
                    let val = parseFloat(value.toString().replace(/\s/g, ''))
                    return val
                }
            },

            onlyForCurrency ($event,val) {
                if(val) {
                    let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
                    // only allow number and one dot
                    if ((keyCode < 48 || keyCode > 57) && (keyCode !== 46 || val.toString().indexOf('.') != -1)) { // 46 is dot
                        $event.preventDefault();
                    }
                    if ((keyCode < 48 || keyCode > 57) && val.length == 0) { // 46 is dot
                        $event.preventDefault();
                    }
                    // restrict to 2 decimal places
                    if (val.toString() != null && val.toString().indexOf(".") > -1 && (val.toString().split('.')[1].length > 1)) {
                        $event.preventDefault();
                    }
                }
            },

            checkboxVal(val){
                if(val == true){
                    return "Да"
                }else if(val == false){
                    return "Нет"
                }
            },

            convertDateTime(date){
                if(date){
                    let date2 = new Date(date);
                    let year = date2.getFullYear();
                    let month = ("0" + (date2.getMonth()+1)).slice(-2);
                    let day = ("0" + date2.getDate()).slice(-2);

                    return  year + '-' + month + '-' + day;
                }

            },

            convertDateTimeISO(date){
                if(date){
                    let date2 = new Date(date);
                    let year = date2.getFullYear();
                    let month = ("0" + (date2.getMonth()+1)).slice(-2);
                    let day = ("0" + date2.getDate()).slice(-2);
                    let hours = ("0" + date2.getHours()).slice(-2);
                    let minutes = ("0" + date2.getMinutes()).slice(-2);
                    let seconds = ("0" + date2.getSeconds()).slice(-2);

                    return  year + '-' + month + '-' + day + ' ' + hours +  ':' + minutes + ':' + seconds;
                }

            },

            wordClose(){
                this.wordDialog = false
                setTimeout(() => {
                    this.startDateWord = ''
                    this.endDateWord = ''
                    this.wordErrorAlert = false

                }, 300)
            },

            forNullData(val){
                  if(val == null){
                      return '—'
                  }else if(val == 0){
                      return '0'
                  } else{
                      return val
                  }
            },

            forNullDataPrice(newValue){
                if(newValue == null){
                    return '—'
                }else if(newValue == 0){
                    return '0'
                } else{
                    let val = newValue.toString().replace(/\s/g, '')

                    return val.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1 ")
                }
            },

            export2Docx (startDate,endDate ) {

                if (this.startDateWord && this.endDateWord) {

                    this.wordErrorAlert = false

                    axios({
                            method: 'get',
                            url: this.backUrl + `/api/bids/report?from_time=${this.convertDateTimeISO(startDate)+ 'Z'}&to_time=${this.convertDateTimeISO(endDate) + 'Z'}`,
                            withCredentials: true,
                            headers: {
                                'Authorization': 'Basic ' + this.token
                            },
                        }).then(response => {


                            if(response.data) {

                                let res = response.data.data[0]

                                const doc = new Document();

                                doc.Styles.createParagraphStyle("tr-style", "tr-style")
                                    .size(28)
                                    .indent({ left: 100 })
                                    .spacing({ line: 300, before: 100})


                                doc.Styles.createParagraphStyle("tr-style2", "tr-style2")
                                    .size(28)
                                    .spacing({ line: 300, before: 100})
                                    .center()



                                doc.Styles.createParagraphStyle("title", "title")
                                    .size(35)
                                    .bold()
                                doc.Styles.createParagraphStyle("title2", "title2")
                                    .size(35)
                                    .bold()
                                    .spacing({ after: 1200});

                                doc.createParagraph("Отчет по заявкам за период").center().style('title');
                                doc.createParagraph('с ' + this.convertDateTimeISO(startDate) + ' по ' + this.convertDateTimeISO(endDate)).center().style('title2');


                                const table = doc.createTable(9, 2);

                                for(let i = 0 ; i < 9; i++){
                                    table.getCell(i, 0).properties.Borders.addTopBorder(BorderStyle.SINGLE, 1, "cccccc")
                                    table.getCell(i, 0).properties.Borders.addStartBorder(BorderStyle.SINGLE, 1, "cccccc")
                                    table.getCell(i, 0).properties.Borders.addEndBorder(BorderStyle.SINGLE, 1, "cccccc")
                                    table.getCell(i, 0).properties.Borders.addBottomBorder(BorderStyle.SINGLE, 1, "cccccc")
                                    table.getCell(i, 1).properties.Borders.addTopBorder(BorderStyle.SINGLE, 1, "cccccc")
                                    table.getCell(i, 1).properties.Borders.addStartBorder(BorderStyle.SINGLE, 1, "cccccc")
                                    table.getCell(i, 1).properties.Borders.addEndBorder(BorderStyle.SINGLE, 1, "cccccc")
                                    table.getCell(i, 1).properties.Borders.addBottomBorder(BorderStyle.SINGLE, 1, "cccccc")
                                    table.getCell(i, 1).properties.setWidth(1500, WidthType.DXA)

                                }

                                table.setWidth( 100,  WidthType.PERCENTAGE);


                                let row = 0;
                                table.getCell(row, 0).addContent(new Paragraph("Общая начальная (максимальная) цена контрактов, руб.").style('tr-style'));
                                table.getCell(row, 1).addContent(new Paragraph(this.forNullDataPrice(res.commonStartContractPrice)).style('tr-style2'));
                                row = 1;
                                table.getCell(row, 0).addContent(new Paragraph("Количество объявленных процедур на этапе подачи заявок").style('tr-style'));
                                table.getCell(row, 1).addContent(new Paragraph(this.forNullData(res.amountOfProceduresAtPublishedStage)).style('tr-style2'));
                                row = 2;
                                table.getCell(row, 0).addContent(new Paragraph("Количество объявленных процедур на этапе работы комиссии").style('tr-style'));
                                table.getCell(row, 1).addContent(new Paragraph(this.forNullData(res.amountOfProceduresAtCommissionWorkStage)).style('tr-style2'));
                                row = 3;
                                table.getCell(row, 0).addContent(new Paragraph("Количество процедур на этапе подготовки к размещению (рабочая группа)").style('tr-style'));
                                table.getCell(row, 1).addContent(new Paragraph(this.forNullData(res.amountOfProceduresAtPreparationStage)).style('tr-style2'));
                                row = 4;
                                table.getCell(row, 0).addContent(new Paragraph("Количество завершенных процедур").style('tr-style'));
                                table.getCell(row, 1).addContent(new Paragraph(this.forNullData(res.amountOfCompletedProcedures)).style('tr-style2'));
                                row = 5;
                                table.getCell(row, 0).addContent(new Paragraph("Сумма экономии на торгах, руб.").style('tr-style'));
                                table.getCell(row, 1).addContent(new Paragraph(this.forNullDataPrice(res.sumOfEconomy)).style('tr-style2'));
                                row = 6;
                                table.getCell(row, 0).addContent(new Paragraph("Процент экономии на торгах, %").style('tr-style'));
                                table.getCell(row, 1).addContent(new Paragraph(this.forNullData(res.percentOfEconomy)).style('tr-style2'));
                                row = 7;
                                table.getCell(row, 0).addContent(new Paragraph("Среднее количество участников на завершенных торгах").style('tr-style'));
                                table.getCell(row, 1).addContent(new Paragraph(this.forNullData(res.averageNumberOfParticipantsInCompletedBids)).style('tr-style2'));
                                row = 8;
                                table.getCell(row, 0).addContent(new Paragraph("Количество несостоявшихся торгов").style('tr-style'));
                                table.getCell(row, 1).addContent(new Paragraph(this.forNullData(res.amountOfUncompletedProcedures)).style('tr-style2'));



                                const packer = new Packer();

                                packer.toBlob(doc).then(blob => {
                                    saveAs(blob, 'Отчет по заявкам за период с ' + this.convertDateTimeISO(startDate) + ' по ' + this.convertDateTimeISO(endDate));
                                });


                                setTimeout(() => {
                                    this.wordClose()
                                }, 300)
                            }else{
                                this.wordErrorText = 'Данные за указанный период отсутствуют'
                                this.wordErrorAlert = true
                            }

                        }).catch(error => {
                                this.wordErrorText = error.response.data.message
                                this.wordErrorAlert = true
                        });
                } else{
                    this.wordErrorText = 'Даты обязательны к заполнению'
                    this.wordErrorAlert = true


                }

            },

            supplierDefinitionTypes(item){

                    if (item == "AUCTION_EL_FORM"){
                        return "Аукцион в электронной форме"
                    }else if (item == "CONSTRUCTION_AUCTION_EL_FORM"){
                        return "Электронный аукцион на проведение работ по строительству, реконструкции, кап. ремонту, сносу объекта кап. строительства, предусматривающих проектную документацию"
                    }else if (item == "OPEN_CONTEST_EL_FORM"){
                        return "Открытый конкурс в электронной форме"
                    }else if (item == "LIMITED_CONTEST"){
                        return "Конкурс с ограниченным участием"
                    }else if (item == "LIMITED_CONTEST_EL_FORM"){
                        return "Конкурс с ограниченным участием в электронной форме"
                    }else if (item == "TWO_STAGE_CONTEST_EL_FORM"){
                        return "Двухэтапный конкурс в электронной форме"
                    }else if (item == "QUOTATION_REQUEST_EL_FORM"){
                        return "Запрос котировок в электронной форме"
                    }else if (item == "HUMANITARIAN_AID_QUOTATION_REQUEST_EL_FORM"){
                        return "Запрос котировок в электронной форме в целях оказания гуманитарной помощи либо ликвидации последствий чрезвычайных ситуаций природного или техногенного характера"
                    }else if (item == "OFFER_REQUEST_EL_FORM"){
                        return "Запрос предложений в электронной форме"
                    }else if (item == "SINGLE_SUPPLIER_PURCHASE_EL_FORM"){
                        return "Закупка товара в случаях, предусмотренных пунктами 4 и 5 части 1 ст. 93 в электронной форме с использованием электронной площадки"
                    }else{
                        return ''
                    }
            },

            justificationTypes(item){
                if (item == "COMPARABLE_MARKET_PRICE"){
                    return "Метод сопоставимых рыночных цен (анализа рынка)"
                }else if (item == "NORMATIVE"){
                    return "Нормативный метод"
                }else if (item == "TARIFF"){
                    return "Тарифный метод"
                }else if (item == "DESIGN_ESTIMATE"){
                    return "Проектно-сметный метод"
                }else if (item == "COSTLY"){
                    return "Затратный метод"
                }else if (item == "OTHER"){
                    return "Иной метод"
                }else{
                    return item
                }
            },

            checkedText(item){

                if (item){
                    return "Предусмотрено"
                }else{
                    return "Не предусмотрено"
                }
            },

            pdfRequest(item){
                this.pdfLoading = item.id
                const targetElement = document.querySelector('#iframeContainer');
                targetElement.innerHTML = '';

                axios({
                    method: 'get',
                    url: this.backUrl + '/api/contracts/' + item.contractId,
                    withCredentials: true,
                    headers:{
                        'Authorization': 'Basic ' + this.token
                    },
                }).then(response => {
                    let data = response.data

                    axios({
                        method: 'get',
                        url: this.backUrl + '/api/customers/' + item.customerId,
                        withCredentials: true,
                        headers:{
                            'Authorization': 'Basic ' + this.token
                        },
                    }).then(response => {
                        let customerData = response.data

                        axios({
                            method: 'get',
                            url: this.backUrl + '/api/accountDetails/' + item.accountDetailsId,
                            withCredentials: true,
                            headers:{
                                'Authorization': 'Basic ' + this.token
                            },
                        }).then(response => {

                            let accountDetailsID = response.data.personalAccount

                            let body = [
                                [  { text: 'Название заказчика, контактная информация', fontSize: 15, alignment:  'center', colSpan: 2, margin: [0 , 5] }, {text:''}],
                                [ 'ИНН', customerData.inn ],
                                [ 'Наименование', customerData.name ],
                                [ 'Телефон', customerData.phone ],
                                [ 'Адрес элетронной почты', customerData.email ],
                                [ 'Адрес (место нахождения)', customerData.address ],
                                [ 'Почтовый адрес', customerData.mailAddress ],
                                [  { text: 'Информация о контрактной службе, контрактном управляющем, ответственных за заключение контракта', fontSize: 15, alignment:  'center', colSpan: 2, margin: [0 , 5] }, {text:''}],
                                [ 'Ф.И.О. контрактного управляющего', data.contractManagerFIO ],
                                [ 'Адрес элетронной почты', data.contractManagerEmail ],
                                [ 'Телефон', data.contractManagerPhone ],
                                [ 'Наименование документа, на основании которого действует руководитель контрактной службы / контрактный управляющий', data.contractDocumentName ],
                                [ 'Дата документа на основании которого действует руководитель контрактной службы / контрактный управляющий', this.dateFormatted(data.contractDocumentDate) ],
                                [ 'Номер документа на основании которого действует руководитель контрактной службы / контрактный управляющий', data.contractDocumentNumber ],
                                [  { text: 'Предмет контракта', fontSize: 15, alignment:  'center', colSpan: 2, margin: [0 , 5] }, {text:''}],
                                [ 'Способ определения поставщика', this.supplierDefinitionTypes(data.supplierDefinitionType) ],
                                [ 'Идентификационный код закупки', data.purchaseId ],
                                [ 'Наименование закупки (предмет лота)', data.name ],
                                [ 'Реестровый номер закупки в ЕАСУЗ', data.purchaseRegNumber ],
                                [ 'Реквизиты счета для перечисления денежных средств', accountDetailsID ],
                                [ 'Невозможно определить количество поставляемых товаров, объем подлежащих выполнению работ, оказанию услуг' , this.checkedText(data.undefinedQuantityUnitsSupplied) ],
                            ]

                            if(data.undefinedQuantityUnitsSupplied){
                                body.push(
                                    [ 'Начальная цена единицы товара, работы, услуги (в руб)', data.startServicePrice ],
                                    [ 'Начальная сумма цен указанных единиц (в руб)', data.startServiceUnitsSum ],
                                    [ 'Максимальное значение цены контракта (в руб)', data.maxContractPrice ],
                                )
                            }else{
                                body.push(
                                    [ 'Начальная (максимальная) цена контракта (в руб)', data.startContractPrice ],
                                    [ 'Метод обоснования НМЦК', this.justificationTypes(data.justificationMethod) ],
                                )
                            }

                            body.push(
                                [ 'Сведения о включенных в цену товара налогов, сборов и других обязательных платежах, а также других расходов', data.otherTaxInPrice ],
                                [ 'Место поставки товаров, выполнения работ, оказания услуг', data.contractExecutionPlace ],
                                [ 'Сроки поставки товара или завершения работы либо график оказания услуг', data.contractExecutionDeadline ],
                                [ 'Порядок и сроки оплаты товара, работы или услуги', data.contractPaymentProcedureAndTerms ],
                                [ 'Источник финансирования', data.financeSource ],
                                [ 'Год финансирования', data.yearsOfFinancing ? data.yearsOfFinancing.join() : '' ],
                            )

                            if(data.supplierDefinitionType !== 'QUOTATION_REQUEST_EL_FORM' && data.startContractPrice >= 1000000 && !data.undefinedQuantityUnitsSupplied){
                                body.push(
                                    [ 'Размер обеспечения заявки (в руб)', item.provisionSize ],
                                )
                            }

                            if(!data.undefinedQuantityUnitsSupplied && data.startContractPrice > 0){
                                body.push(
                                    [ 'Размер обеспечения исполнения контракта (в руб)', data.provisionSize ? data.provisionSize : ' -- ' ],
                                )
                            }

                            body.push(
                                [  { text: 'Возможность заказчика изменить условия контракта', fontSize: 15, alignment:  'center', colSpan: 2, margin: [0 , 5] }, {text:''}],
                                [ 'При снижении цены контракта без изменения предусмотренных контрактом количества товара, объема работы или услуги, качества поставляемого товара, выполняемой работы, оказываемой услуги и иных условий контракта' , this.checkedText(data.contractConditionsCanBeChanged1) ],
                                [ 'Если по предложению заказчика увеличиваются/уменьшается предусмотренные контрактом (за исключением работ по строительству, реконструкции, капитальному ремонту, сносу объекта капитального строительства) количество товара, объем работы или услуги не более чем на десять процентов' , this.checkedText(data.contractConditionsCanBeChanged2) ],
                                [ 'При заключении контракта увеличение количества поставляемого товара на сумму, не превышающую разницы между ценой контракта, предложенной таким участником, и начальной (максимальной) ценой контракта (ценой лота)' , this.checkedText(data.contractConditionsCanBeChanged3) ],
                                [ 'При изменении объема и (или) видов выполняемых работ по контракту, предметом которого является выполнение работ по строительству, реконструкции, капитальному ремонту, сносу объекта капитального строительства, проведению работ по сохранению объектов культурного наследия. При этом допускается изменение с учетом положений бюджетного законодательства Российской Федерации цены контракта не более чем на десять процентов цены контракта' , this.checkedText(data.contractConditionsCanBeChanged4) ],
                                [ 'Возможность одностороннего отказа от исполнения контракта' , this.checkedText(data.unilateralRefusal) ],
                                [  { text: 'Другие условия', fontSize: 15, alignment:  'center', colSpan: 2, margin: [0 , 5] }, {text:''}],
                                [ 'Преимущества учреждениям и предприятиям уголовно-исполнительной системы' , this.checkedText(data.penalSystemPart) ],
                                [ 'Преимущества организациям инвалидов' , this.checkedText(data.disabledPeopleOrgPart) ],
                                [ 'Участие в определении поставщика (подрядчика, исполнителя) субъектов малого предпринимательства или социально ориентированных некоммерческих организаций' , this.checkedText(data.definitionCustomerPart) ],
                                [ 'Требование к участнику, не являющемуся субъектом малого предпринимательства или социально ориентированной некоммерческой организацией, о привлечении к исполнению контракта субподрядчиков, соисполнителей из числа субъектов малого предпринимательства, социально ориентированных некоммерческих организаций' , this.checkedText(data.requirementForParticipant) ],
                            )


                            if(!data.definitionCustomerPart && data.requirementForParticipant){
                                body.push(
                                    [ 'Объем привлечения (в процентах)', data.attractionPercent ],
                                )
                            }

                            body.push(
                                [  'Требование к участнику в соответствии с пунктом 1 части 1 и частью 2 статьи 31 Федерального закона №44-ФЗ', data.fz_44 ]
                            )

                            let dd = {
                                pageMargins: [ 40, 60, 40, 60 ],
                                info: {
                                    title: 'Заявка №'+ item.id,
                                },
                                footer : function(currentPage, pageCount) {
                                    return {
                                        margin : [ 20, 10, 20,20],
                                        fontSize : 8,
                                        columns : [
                                            {
                                                text : '' ,
                                                alignment : 'left',
                                                bold : true
                                            },
                                            {
                                                text : currentPage.toString() + ' из '
                                                    + pageCount,
                                                alignment : 'center',
                                                bold : true
                                            }, {
                                                text : '',
                                                alignment : 'right',
                                                bold : true
                                            } ]
                                    };
                                },
                                content: [
                                    { text: 'Заявка №'+ item.id, fontSize: 22,bold: true, alignment:  'center' },
                                    ' ',
                                    ' ',
                                    ' ',
                                    {
                                        table: {
                                            widths: [ '50%', 'auto' ],
                                            body: body,
                                        }
                                    },

                                ],
                            }
                            const pdfDocGenerator = pdfMake.createPdf(dd);

                            pdfDocGenerator.getDataUrl((dataUrl) => {

                                const targetElement = document.querySelector('#iframeContainer');
                                const iframe = document.createElement('iframe');
                                iframe.src = dataUrl;
                                targetElement.appendChild(iframe);
                            });
                                this.pdfLoading = false
                                this.pdfDialog = true
                        })
                    })

                })

            }
        }

    }
</script>

<style scoped>
    .filter-menu{
        margin: 5px 0;
    }
</style>
<style>
    .table-filter .v-input__control{
        height: 30px!important;
        min-height: unset!important;
    }
    .filter-row{
        border-bottom: 1px solid #ccc;
    }
    .over-table .v-table__overflow{
        display: block;
        max-height: calc(100vh - 215px);
        overflow: auto;
    }
    .over-table .v-datatable thead .title-tr th{
        position: sticky;
        top: 0;
        background: #fff;
        z-index: 5;
    }
    .title-tr,.filter-tr{
        border: unset!important;
    }
    .over-table .v-datatable thead .filter-tr th{
        position: -webkit-sticky;
        position: sticky;
        top: 56px;
        z-index: 5;
        background: #f7f4f4;
        padding: 0 5px!important;
    }
    .v-table__overflow::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }
    .v-table__overflow::-webkit-scrollbar-track {
        border-radius: 10px;
        background: #fff;
    }

    /* Handle */
    .v-table__overflow::-webkit-scrollbar-thumb {
        background: #2196f3;
        border-radius: 10px;
    }

    .v-dialog:not(.v-dialog--fullscreen) {
        max-height: 100%!important;
    }
    #iframeContainer iframe{
        width: 100% ;
        height: 90vh;
    }
    .uu-actions{
        width: 308px!important;
    }
    .customer-actions{
        width: 264px!important;
    }
    .column-picker{
        box-shadow: unset!important;
        padding-right: 10px;
    }
    .date-column-title{
        margin-bottom: 20px;
    }
    .v-small-dialog__actions{
        text-align: center!important;
    }
   /*.menuable__content__active{*/
   /*     max-height: 500px!important;*/
   /* }*/
    .request-table .v-menu .v-text-field{
        margin-top: 0!important;
    }
    .request-table .v-menu .v-input__slot{
        margin-bottom: 0!important;
    }
    .request-table .v-menu .v-input input{
        font-size: 13px!important;
    }
    .request-table .v-text-field > .v-input__control > .v-input__slot:before, .request-table .v-text-field > .v-input__control > .v-input__slot:after{
        width: unset!important;
    }
    .flight-menu{
        margin-bottom:20px;
    }
    .hidden{
        display: none;
    }
    table td,table th {
        padding: 0 12px!important;
    }
    .flight-actions{
        width: 156px;
    }
    .edit-classes{
        height: unset!important;
    }
    .new-request-row{
        background-color: #ffeacb!important;
    }
    .request-change{
        cursor: unset!important;
    }
    .editable-col:after {
        content: '\F040';
        font-family: FontAwesome;
        font-style: normal;
        text-decoration: inherit;
        color: #1976d2;
        font-size: 15px;
        margin-left: 5px;
    }
    .filter-select.v-input--is-dirty,.multiple-select.v-input--is-dirty{
        max-width: 400px;
    }
    .filter-select .v-select__selections {
        overflow: hidden;
    }
    .filter-select .v-select__selection--comma {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        display: block;
    }
    .multiple-select .v-select__selections{
        white-space: nowrap;
        overflow: hidden;
        display: inline-table;
    }

</style>